import React from "react";
import { v4 as uuid } from "uuid";
import { withStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import FormRenderer from "./formRender";
import MutextField from "@material-ui/core/TextField";
import axios from "axios";
import Select2 from "react-select";
import RichTextEditorComponent from "../../components/Reseller/RichTextEditorComponent";
import DOMPurify from "dompurify";
import { getIntegration, getOutboundSBCIntegration } from "./../../config/reseller_api_calls";
import { isFccIntegrationEnabled } from "./../../config/api_calls";
import HelperClass from "./../../config/helperClass";
const auth = new HelperClass();

const useStyles = (theme) => ({
  formContainer: {
    marginBottom: theme.spacing(2),
    //padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    width: "100%",
    margin: "auto",
    //marginTop: "1rem",
  },
  questionContainer: {
    marginBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid #dbdfea",
    paddingBottom: "1rem",
  },
  questionTop: {
    display: "flex",
  },
  optionContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  addButton: {
    marginBottom: "10px",
    marginTop: "10px",
  },
  deleteButton: {
    marginLeft: theme.spacing(2),
  },
});

const STATIC_TEXT_ANSWER_TYPES = [
  "text_only",
  "rich_text",
  "notice_text",
  "warning_text",
];

const RICH_EDITOR_ANSWER_TYPES = ["rich_text", "notice_text", "warning_text"];

/*const accountCreationOptions = [
  { label: "", value: "" }, // Empty/default option
  { label: "Full Name", value: "fullname" },
  { label: "Company", value: "company" },
  { label: "Email Address", value: "email" },
  { label: "Phone", value: "phone" },
  { label: "Full Address", value: "full_address" },
  { label: "Address", value: "address" },
  { label: "Appartment, Suite", value: "address2" },
  { label: "City", value: "city" },
  { label: "State", value: "state" },
  { label: "Zip", value: "zip" },
  { label: "Country", value: "country" },
];*/

class FormBuilderClass extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);
    let form_content = this.props.form_content;
    //console.log("form_content: ", form_content);
    let form_title =
      this.props.form_title && this.props.form_title !== ""
        ? this.props.form_title
        : "";
    let chatgpt_intergation =
      this.props.chatgpt_intergation && this.props.chatgpt_intergation !== ""
        ? this.props.chatgpt_intergation
        : "";
    // console.log("chatgpt_intergation:");
    if (!form_content || form_content === "" || form_content.length <= 0) {
      form_content = [
        {
          title: "",
          id: uuid(),
          questions: [],
          /*questions: [
            {
              id: uuid(),
              questionText: "",
              answerType: "",
              required: false,
              options: [],
              imageUrl: "",
            },
          ],*/
          errorMessage: "",
        },
      ];
    }
    let groups = [];
    if (this.props.groups) {
      groups = this.props.groups.sort(
        (a, b) => a.sequenceNumber - b.sequenceNumber,
      );
    }
    //Add group id if missing
    groups = groups.map((group) => {
      if (!group.id || group.id === "") {
        return {
          ...group,
          id: uuid(),
          column_layout: group.column_layout || "single_column",
        };
      }
      return {
        ...group,
        column_layout: group.column_layout || "single_column",
      };
    });

    //let link_form = this.props.link_form ? "Yes" : "No";

    this.state = {
      form_title: form_title,
      forms: form_content,
      chatgpt_intergation: chatgpt_intergation,
      showSelectList: false,
      //groups: this.props.groups ?? [],
      groups: groups,
      currentGroup: {
        group_title: "",
        group_instructions: "",
        group_desc: "",
        questions: [],
        sequenceNumber: 1,
        column_layout: "single_column",
      },
      editingGroupIndex: null,
      groupErrorMessageTitle: "",
      groupErrorMessage: "",
      groupSuccessMessage: "",
      questionErrorMessageTitle: "",
      questionErrorMessage: "",
      questionSuccessMessage: "",
      newQuestion: [{}],
      current_form_id: "",
      selected_group: "",
      all_questions: [],
      unassigned_questions: [],
      add_question_loader: false,
      add_group_loader: false,
      isEditorReady: false,
      delete_group: "",
      isDeleting: false,
      isDeletingAll: false,
      allowAIQuestion: false,
      currentAnswerType: "",
      chatgpt_intergation: "No",
      is_fcc_enabled: "No",
      is_outbound_sbc_enabled: "No",
      ///link_form: link_form,
      accountCreationOptions: [
        { label: "", value: "" }, // Empty/default option
        { label: "Full Name", value: "fullname" },
        { label: "Title", value: "title" },
        { label: "Company", value: "company" },
        { label: "Email Address", value: "email" },
        { label: "Phone", value: "phone" },
        { label: "Full Address", value: "full_address" },
        /*{ label: "Address", value: "address" },
        { label: "Appartment, Suite", value: "address2" },
        { label: "City", value: "city" },
        { label: "State", value: "state" },
        { label: "Zip", value: "zip" },
        { label: "Country", value: "country" },*/
      ],
    };
  }

  getAllQuestions = (groups) => {
    if (groups && groups.length > 0) {
      return groups.flatMap((group) => group.questions);
    }
  };

  componentDidMount() {
    this.get_integration_data();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.forms !== this.state.forms) {
      this.props.onFormContentChange(this.state.forms);
    }

    if (prevState.groups !== this.state.groups) {
      this.props.onGroupsChange(this.state.groups); // Notify parent of group changes
    }
  }

  get_integration_data = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getIntegration(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("get_integration_data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let chatgpt_intergation = "No";
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          if (
            servicesResponce.data.data[i]["integration_type"] === "chatgpt" &&
            servicesResponce.data.data[i]["active"] === 1 &&
            servicesResponce.data.data[i]["status"] === "Yes"
          ) {
            chatgpt_intergation = "Yes";
          }
        }
      }
      this.setState({
        chatgpt_intergation: chatgpt_intergation,
      });
    } else {
    }

    // Check FCC integration status
    try {
      const fccResponse = await isFccIntegrationEnabled(
        auth.getAccount(),
        auth.getToken(),
      );
      if (
        fccResponse.data.status === 200 &&
        fccResponse.data.message === "success"
      ) {
        this.setState({
          is_fcc_enabled: fccResponse.data.is_fcc_enabled || "No",
        });
      }
    } catch (e) {
      // FCC check failed, keep default "No"
    }

    // Check Outbound SBC integration status
    try {
      const outboundSBCResponse = await getOutboundSBCIntegration(
        auth.getAccount(),
        auth.getToken(),
      );
      if (
        outboundSBCResponse.data.status === 200 &&
        outboundSBCResponse.data.message === "success" &&
        outboundSBCResponse.data.data &&
        outboundSBCResponse.data.data.is_enabled === 1
      ) {
        this.setState({ is_outbound_sbc_enabled: "Yes" });
      }
    } catch (e) {
      // Outbound SBC check failed, keep default "No"
    }
  };

  handleQuestionTextChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, questionText: value }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleTooltipChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, tooltip: value }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleDefaultValueChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, defaultValue: value }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleSequenceChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, sequenceNumber: value }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleAnswerTypeChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, answerType: value, options: [] }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleDynamicValue = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, dynamicValue: value, options: [] }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleCreateAccount = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, createAccount: value, options: [] }
                  : question,
              ),
            }
          : form,
      ),
    }));
    this.setState((prevState) => ({
      accountCreationOptions: prevState.accountCreationOptions.map((option) =>
        option.value === value ? { ...option, disabled: true } : option,
      ),
    }));
  };

  handleRequiredChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, required: value === "true" }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleOptionChange = (formId, questionId, optionIndex, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? {
                      ...question,
                      options: question.options.map((option, index) =>
                        index === optionIndex ? value : option,
                      ),
                    }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleFixedOption = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, answer: value }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleAddOption = (formId, questionId) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, options: [...question.options, ""] }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleDeleteOption = (formId, questionId, optionIndex) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? {
                      ...question,
                      options: question.options.filter(
                        (_, index) => index !== optionIndex,
                      ),
                    }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleAddQuestion = (formId) => {
    const newQuestion = {
      id: uuid(),
      questionText: "",
      answerType: "",
      required: false,
      options: [],
      imageUrl: "",
    };
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? { ...form, questions: [...form.questions, newQuestion] }
          : form,
      ),
    }));
  };

  handleDeleteQuestion = (formId, questionId) => {
    this.setState((prevState) => {
      // Find which group owns this question so we can re-sequence within it
      const ownerGroup = prevState.groups.find((g) =>
        g.questions.includes(questionId),
      );

      // Remove the question from forms and re-sequence siblings in the same group
      const updatedForms = prevState.forms.map((form) => {
        if (form.id !== formId) return form;
        const remaining = form.questions.filter((q) => q.id !== questionId);
        if (!ownerGroup) return { ...form, questions: remaining };
        // Re-sequence questions that belong to the same group, compacting gaps
        const groupQIds = ownerGroup.questions.filter((id) => id !== questionId);
        const groupQs = remaining
          .filter((q) => groupQIds.includes(q.id))
          .sort((a, b) => parseInt(a.sequenceNumber) - parseInt(b.sequenceNumber))
          .map((q, i) => ({ ...q, sequenceNumber: String(i + 1) }));
        const nonGroupQs = remaining.filter((q) => !groupQIds.includes(q.id));
        return { ...form, questions: [...nonGroupQs, ...groupQs] };
      });

      // Remove the question ID from its group's questions list
      const updatedGroups = prevState.groups.map((g) =>
        g.questions.includes(questionId)
          ? { ...g, questions: g.questions.filter((id) => id !== questionId) }
          : g,
      );

      return { forms: updatedForms, groups: updatedGroups };
    });
  };

  handleImageUpload = (formId, questionId, event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      axios
        .post(
          `${process.env.REACT_APP_API_URL}forms/form_image_admin`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        )
        .then((response) => {
          const imageUrl = response.data.default;
          this.setState((prevState) => ({
            forms: prevState.forms.map((form) =>
              form.id === formId
                ? {
                    ...form,
                    questions: form.questions.map((question) =>
                      question.id === questionId
                        ? { ...question, imageUrl }
                        : question,
                    ),
                  }
                : form,
            ),
          }));
        })
        .catch((error) => {
          // console.error("There was an error uploading the image!", error);
        });
    }
  };

  handleSaveForm = () => {
    this.props.onFormSubmit();
  };

  handleOpenForm = () => {
    const previewContent = (
      <FormRenderer
        formData={this.state.forms}
        formTitle={this.state.form_title}
        id={this.state.forms[0].id}
      />
    );
    this.setState({ previewContent }, () => {
      window.$("#modalPreviewForm").modal("show");
    });
  };

  handleSelectChange = (selectedOptions) => {
    const { groups, currentGroup, editingGroupIndex } = this.state;
    const updatedCurrentGroup = {
      ...currentGroup,
      questions: selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [],
    };
    const updatedGroups = [...groups];
    updatedGroups[editingGroupIndex] = updatedCurrentGroup;

    this.setState({
      groups: updatedGroups,
      currentGroup: updatedCurrentGroup,
    });
  };

  handleGroupQuestions = () => {
    this.setState((prevState) => ({
      showSelectList: !prevState.showSelectList,
    }));
    const element = document.getElementById("groupEditDiv");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  handleGroupTitleChange = (event) => {
    this.setState((prevState) => ({
      currentGroup: {
        ...prevState.currentGroup,
        group_title: event.target.value,
      },
    }));
  };

  handleGroupDescChange = (event) => {
    this.setState((prevState) => ({
      currentGroup: {
        ...prevState.currentGroup,
        group_desc: event.target.value,
      },
    }));
  };

  handleEditorChange = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState((prevState) => ({
      currentGroup: {
        ...prevState.currentGroup,
        group_desc: updatedContent,
      },
    }));
    //this.setState({ form_desc: updatedContent });
  };

  handleEditorChangeEdit = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState((prevState) => ({
      currentGroup: {
        ...prevState.currentGroup,
        group_desc: updatedContent,
      },
    }));
    //this.setState({ form_desc: updatedContent });
  };

  handleAddGroup = () => {
    const { groups, currentGroup, editingGroupIndex } = this.state;

    if (editingGroupIndex !== null) {
      const updatedGroups = [...groups];
      updatedGroups[editingGroupIndex] = currentGroup;
      this.setState({
        groups: updatedGroups,
        currentGroup: {
          group_title: "",
          group_instructions: "",
          group_desc: "",
          sequenceNumber: "",
          questions: [],
          allowBcid: "",
          column_layout: "single_column",
        },
        showSelectList: false,
        editingGroupIndex: null,
      });
    } else {
      this.setState({
        groups: [...groups, currentGroup],
        currentGroup: {
          id: uuid(),
          group_title: "",
          group_instructions: "",
          group_desc: "",
          sequenceNumber: "",
          questions: [],
          allowBcid: "",
          column_layout: "single_column",
        },
        showSelectList: false,
      });
    }
  };

  handleGroupSequenceChange = (event) => {
    const sequenceNumber = event.target.value;
    this.setState((prevState) => ({
      currentGroup: {
        ...prevState.currentGroup,
        sequenceNumber: sequenceNumber,
      },
    }));
  };

  handleGroupAPIChange = (event) => {
    //const { currentGroup } = this.state;
    //console.log("allowBcid.value: ", event.target.value);
    const allowBcid = event.target.value;
    this.setState((prevState) => ({
      currentGroup: {
        ...prevState.currentGroup,
        allowBcid: allowBcid,
      },
    }));
    //console.log("API Current Group: ", this.state.currentGroup);
  };

  handleGroupColumnLayoutChange = (event) => {
    this.setState((prevState) => ({
      currentGroup: {
        ...prevState.currentGroup,
        column_layout: event.target.value,
      },
    }));
  };

  isStaticTextAnswerType = (answerType) => {
    return STATIC_TEXT_ANSWER_TYPES.includes(answerType);
  };

  isRichEditorAnswerType = (answerType) => {
    return RICH_EDITOR_ANSWER_TYPES.includes(answerType);
  };

  handleEditGroup = (index) => {
    const group = this.state.groups[index];
    this.setState({
      editingGroupIndex: index,
      currentGroup: {
        group_title: group.group_title,
        group_desc: group.group_desc,
        group_instructions: group.group_instructions,
        sequenceNumber: group.sequenceNumber,
        questions: group.questions,
        column_layout: group.column_layout || "single_column",
      },
      showSelectList: true,
    });
    const element = document.getElementById("groupEditDiv");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  handleCancelEdit = () => {
    this.setState({
      currentGroup: {
        group_title: "",
        group_desc: "",
        group_instructions: "",
        sequenceNumber: "",
        questions: [],
        column_layout: "single_column",
      },
      showSelectList: false,
      editingGroupIndex: null,
    });
  };

  scrollToDiv = () => {
    const element = document.getElementById("groupEditDiv");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  addGroup = () => {
    /*this.setState((prevState) => ({
      showSelectList: !prevState.showSelectList,
    }));*/
    this.setState(
      {
        currentGroup: {
          id: uuid(),
          group_title: "",
          group_desc: "",
          group_instructions: "",
          sequenceNumber: "",
          questions: [],
          column_layout: "single_column",
        },
        add_group_loader: false,
        groupErrorMessageTitle: "",
        groupErrorMessage: "",
        groupSuccessMessage: "",
        isEditorReady: false,
      },
      () => {
        setTimeout(() => {
          this.setState({ isEditorReady: true });
        }, 500);
      },
    );
    window.$("#modalAddGroup").modal("show");
  };

  handleAddGroupNew = () => {
    const { groups, currentGroup, editingGroupIndex } = this.state;
    if (!currentGroup.group_title.trim()) {
      this.setState({
        groupErrorMessageTitle: "Error",
        groupErrorMessage: "Group title cannot be empty.",
      });

      setTimeout(() => {
        this.setState({ groupErrorMessage: "" });
      }, 3000);

      return;
    }

    if (!String(currentGroup.sequenceNumber).trim()) {
      this.setState({
        groupErrorMessageTitle: "Error",
        groupErrorMessage: "Sequence number cannot be empty.",
      });

      setTimeout(() => {
        this.setState({ groupErrorMessage: "" });
      }, 3000);

      return;
    }

    const seqNum = parseInt(currentGroup.sequenceNumber);
    const shiftedGroups = groups.map((g) => {
      const gSeq = parseInt(g.sequenceNumber);
      return !isNaN(gSeq) && gSeq >= seqNum
        ? { ...g, sequenceNumber: String(gSeq + 1) }
        : g;
    });

    currentGroup.group_desc = DOMPurify.sanitize(currentGroup.group_desc);
    currentGroup.group_desc = currentGroup.group_desc.replace(/\n+/g, "");
    currentGroup.column_layout =
      currentGroup.column_layout || "single_column";
    const newGroups = [...shiftedGroups, currentGroup].sort(
      (a, b) => parseInt(a.sequenceNumber) - parseInt(b.sequenceNumber)
    );
    this.setState({
      groups: newGroups,
      currentGroup: {
        group_title: "",
        group_desc: "",
        group_instructions: "",
        sequenceNumber: "",
        questions: [],
        column_layout: "single_column",
      },
      add_group_loader: true,
      showSelectList: false,
      groupSuccessMessage: "Group added successfully.",
    });
    setTimeout(() => {
      window.$("#modalAddGroup").modal("hide");
    }, 3000);
  };

  editGroupNew = (index) => {
    const group = this.state.groups[index];
    this.setState(
      {
        editingGroupIndex: index,
        currentGroup: {
          id: group.id,
          group_title: group.group_title,
          group_desc: group.group_desc,
          group_instructions:
            group.group_instructions && group.group_instructions !== ""
              ? group.group_instructions
              : "",
          sequenceNumber: group.sequenceNumber,
          questions: group.questions,
          allowBcid: group.allowBcid,
          column_layout: group.column_layout || "single_column",
        },
        groupErrorMessageTitle: "",
        groupErrorMessage: "",
        groupSuccessMessage: "",
        isEditorReady: false,
      },
      () => {
        setTimeout(() => {
          this.setState({ isEditorReady: true });
        }, 500);
      },
    );

    window.$("#modalEditGroup").modal("show");
  };

  handleEditGroupNew = () => {
    const { groups, currentGroup, editingGroupIndex } = this.state;
    if (!currentGroup.group_title.trim()) {
      this.setState({
        groupErrorMessageTitle: "Error",
        groupErrorMessage: "Group title cannot be empty.",
      });

      setTimeout(() => {
        this.setState({ groupErrorMessage: "" });
      }, 3000);

      return;
    }

    if (!String(currentGroup.sequenceNumber).trim()) {
      this.setState({
        groupErrorMessageTitle: "Error",
        groupErrorMessage: "Sequence number cannot be empty.",
      });

      setTimeout(() => {
        this.setState({ groupErrorMessage: "" });
      }, 3000);

      return;
    }

    const seqNum = parseInt(currentGroup.sequenceNumber);
    const shiftedGroups = groups.map((g, idx) => {
      if (idx === editingGroupIndex) return g;
      const gSeq = parseInt(g.sequenceNumber);
      return !isNaN(gSeq) && gSeq >= seqNum
        ? { ...g, sequenceNumber: String(gSeq + 1) }
        : g;
    });

    //console.log("groups: ", groups);
    //console.log("currentGroup: ", currentGroup);
    currentGroup.group_desc = DOMPurify.sanitize(currentGroup.group_desc);
    currentGroup.group_desc = currentGroup.group_desc.replace(/\n+/g, "");
    currentGroup.column_layout =
      currentGroup.column_layout || "single_column";
    const updatedGroups = [...shiftedGroups];
    updatedGroups[editingGroupIndex] = currentGroup;
    const sortedGroups = updatedGroups.sort(
      (a, b) => parseInt(a.sequenceNumber) - parseInt(b.sequenceNumber)
    );
    this.setState({
      groups: sortedGroups,
      groupSuccessMessage: "Group updated successfully.",
    });
    setTimeout(() => {
      window.$("#modalEditGroup").modal("hide");
    }, 3000);
  };

  addNewQuestion = (formId) => {
    const newQuestion = [
      {
        id: uuid(),
        questionText: "",
        answerType: "",
        required: false,
        options: [],
        imageUrl: "",
        dynamicValue: "",
        sequenceNumber: "",
        allowAI: false,
      },
    ];
    this.setState({
      add_question_loader: false,
      questionErrorMessageTitle: "",
      questionErrorMessage: "",
      questionSuccessMessage: "",
      newQuestion: newQuestion,
      current_form_id: formId,
      allowAIQuestion: false,
    });

    window.$("#modalAddQuestion").modal("show");
  };

  handleSequenceChange_new = (questionId, event) => {
    const newSequenceNumber = event.target.value;
    //console.log("newSequenceNumber: ", newSequenceNumber);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, sequenceNumber: newSequenceNumber };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleQuestionTextChange_new = (questionId, event) => {
    const newQuestionText = event.target.value;
    //console.log("questionText: ", newQuestionText);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, questionText: newQuestionText };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleTooltipChange_new = (questionId, event) => {
    const newQuestionText = event.target.value;
    //console.log("questionText: ", newQuestionText);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, tooltip: newQuestionText };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleAnswerTypeChange_new = (questionId, event) => {
    const newAnswerType = event.target.value;
    //console.log("answerType: ", newAnswerType);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, answerType: newAnswerType, options: [] };
          }
          return question;
        });

        return {
          newQuestion: updatedQuestions,
          currentAnswerType: newAnswerType,
        };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleDynamicValue_new = (questionId, event) => {
    const dynamicValue = event.target.value;
    //console.log("dynamicValue: ", dynamicValue);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, dynamicValue: dynamicValue };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleCreateAccount_new = (questionId, event) => {
    const createAccount = event.target.value;
    //console.log("createAccount: ", createAccount);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, createAccount: createAccount };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
    this.setState((prevState) => ({
      accountCreationOptions: prevState.accountCreationOptions.map((option) =>
        option.value === createAccount ? { ...option, disabled: true } : option,
      ),
    }));
  };

  handleRequiredChange_new = (questionId, event) => {
    const newRequired = event.target.value;
    //console.log("dynamicValue: ", newRequired);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, required: newRequired === "true" };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleOptionChange_new = (questionId, optionIndex, event) => {
    const newRequired = event.target.value;
    //console.log("dynamicValue: ", newRequired);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return {
              ...question,
              options: question.options.map((option, index) =>
                index === optionIndex ? newRequired : option,
              ),
            };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleDeleteOption_new = (questionId, optionIndex) => {
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return {
              ...question,
              options: question.options.filter(
                (_, index) => index !== optionIndex,
              ),
            };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleFixedOption_new = (questionId, event) => {
    const newRequired = event.target.value;
    //console.log("dynamicValue: ", newRequired);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, answer: newRequired };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleAddOption_new = (questionId) => {
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, options: [...question.options, ""] };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  submitNewQuestion = () => {
    const { newQuestion, current_form_id, selected_group, allowAIQuestion } =
      this.state;
    //console.log("submitNewQuestion selected_group: ", selected_group);
    //console.log("submitNewQuestion newQuestion: ", newQuestion[0]);
    this.setState({ add_question_loader: true });
    let questionText = "";
    let answerType = "";
    if (newQuestion && newQuestion.length > 0) {
      questionText = newQuestion[0].questionText;
      answerType = newQuestion[0].answerType;
    }
    if (questionText === "") {
      this.setState({
        questionErrorMessageTitle: "Missing Input",
        questionErrorMessage: "Please enter the question text.",
        questionSuccessMessage: "",
        add_question_loader: false,
      });
    } else if (answerType === "") {
      this.setState({
        questionErrorMessageTitle: "Missing Input",
        questionErrorMessage: "Please select answer type.",
        questionSuccessMessage: "",
        add_question_loader: false,
      });
    } else if (selected_group === "") {
      this.setState({
        questionErrorMessageTitle: "Missing Input",
        questionErrorMessage: "Please select group.",
        questionSuccessMessage: "",
        add_question_loader: false,
      });
    } else {
      const seqVal = newQuestion[0].sequenceNumber;
      const newSeq = seqVal !== "" && seqVal !== undefined ? parseInt(seqVal) : NaN;

      const updatedQuestion = {
        ...newQuestion[0],
        allowAI: allowAIQuestion ? 1 : 0, // store as 1/0 or true/false
      };

      //UPDATE FORMS — shift existing questions in the target group if needed, then append
      this.setState(
        (prevState) => {
          const formExists = prevState.forms.some(
            (form) => form.id === current_form_id,
          );
          if (!formExists) {
            // console.error("Form with the given ID does not exist.");
            return prevState; // No changes to state
          }

          const selectedGroupObj = prevState.groups.find((g) => g.id === selected_group);
          const groupQuestionIds = selectedGroupObj ? selectedGroupObj.questions : [];

          const updatedForms = prevState.forms.map((form) => {
            if (form.id !== current_form_id) return form;
            const shiftedQuestions = form.questions.map((q) => {
              if (!isNaN(newSeq) && groupQuestionIds.includes(q.id)) {
                const qSeq = parseInt(q.sequenceNumber);
                if (!isNaN(qSeq) && qSeq >= newSeq) {
                  return { ...q, sequenceNumber: String(qSeq + 1) };
                }
              }
              return q;
            });
            const allQuestions = [...shiftedQuestions, updatedQuestion];
            // Sort questions that belong to the target group by sequenceNumber; keep others in place
            const groupQs = allQuestions
              .filter((q) => groupQuestionIds.includes(q.id) || q.id === updatedQuestion.id)
              .sort((a, b) => parseInt(a.sequenceNumber) - parseInt(b.sequenceNumber));
            const nonGroupQs = allQuestions.filter(
              (q) => !groupQuestionIds.includes(q.id) && q.id !== updatedQuestion.id
            );
            return { ...form, questions: [...nonGroupQs, ...groupQs] };
          });

          //console.log("Updated Forms state:", updatedForms); // Log updated forms state before setting it

          return { forms: updatedForms };
        },
        () => {
          // Callback function to log the state after it has been updated
          //console.log("State after setState:", this.state.forms);
        },
      );

      this.setState(
        (prevState) => {
          // Update the groups array
          const updatedGroups = prevState.groups.map((group) => {
            // Check if this is the group to update
            if (group.id === selected_group) {
              // Replace `selectedGroupId` with the actual ID of the group you're updating
              return {
                ...group,
                questions: [...group.questions, updatedQuestion.id], // Add new question ID to the array
              };
            }
            return group; // Return other groups unchanged
          });

          // Return the updated state
          return { groups: updatedGroups };
        },
        () => {
          // Callback to log the state after update
          //console.log("Updated Groups state:", this.state.groups);
        },
      );

      this.setState({
        questionErrorMessageTitle: "",
        questionErrorMessage: "",
        questionSuccessMessage: "Question added successfully.",
      });
      setTimeout(() => {
        this.setState({
          questionErrorMessageTitle: "",
          questionErrorMessage: "",
          questionSuccessMessage: "",
        });
        window.$("#modalAddQuestion").modal("hide");
      }, 3000);
    }
    setTimeout(() => {
      this.setState({
        questionErrorMessageTitle: "",
        questionErrorMessage: "",
        questionSuccessMessage: "",
      });
    }, 3000);
  };

  handleAddQuestion2 = (formId) => {
    const newQuestion = {
      id: uuid(),
      questionText: "",
      answerType: "",
      required: false,
      options: [],
      imageUrl: "",
    };
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? { ...form, questions: [...form.questions, newQuestion] }
          : form,
      ),
    }));
  };

  closeModal = (modal_id) => {
    window.$("#" + modal_id).modal("hide");
  };

  checkIfIdExists = (idArray, id) => {
    return idArray.includes(id);
  };

  checkIfIdDoesNotExist = (groups, idToCheck) => {
    // Initialize a flag to indicate if the ID is found
    let idFound = false;

    // Iterate over each group
    for (const group of groups) {
      // Check if the questions array includes the ID
      if (
        Array.isArray(group.questions) &&
        group.questions.includes(idToCheck)
      ) {
        idFound = true;
        break;
      }
    }

    // If the ID was not found, handle it here
    if (!idFound) {
      //console.log(`ID "${idToCheck}" does not exist in any questions array.`);
      return true;
    } else {
      //console.log(`ID "${idToCheck}" exists in one of the questions arrays.`);
      return false;
    }
  };

  handleValidationValueChange_new = (questionId, event) => {
    const newValidationValue = event.target.value;
    //console.log("validationValue: ", newValidationValue);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return {
              ...question,
              validationValue: newValidationValue,
              options: [],
            };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleValidationValue = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, validationValue: value, options: [] }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleValidationValueChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, validationValue: value, options: [] }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  openDelForm = async (index) => {
    this.setState({
      groupErrorMessage: "",
      groupSuccessMessage: "",
      delete_group: index,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  deleteGroupandQuestions = () => {
    const { groups, forms, delete_group } = this.state;

    const groupToDelete = groups[delete_group];
    if (!groupToDelete) {
      this.setState({
        groupErrorMessage: "Group not found.",
        isDeletingAll: false,
      });
      return;
    }

    const questionIdsToDelete = groupToDelete.questions;

    const deletedSeq = parseInt(groupToDelete.sequenceNumber);
    const updatedGroups = groups
      .filter((_, i) => i !== delete_group)
      .map((g) => {
        const gSeq = parseInt(g.sequenceNumber);
        return !isNaN(deletedSeq) && !isNaN(gSeq) && gSeq > deletedSeq
          ? { ...g, sequenceNumber: String(gSeq - 1) }
          : g;
      });

    const updatedForms = forms.map((form) => {
      if (!form.questions) return form;

      const filteredQuestions = form.questions.filter(
        (question) => !questionIdsToDelete.includes(question.id),
      );

      return { ...form, questions: filteredQuestions };
    });

    this.setState({ isDeletingAll: true });

    setTimeout(() => {
      this.setState(
        {
          groups: updatedGroups,
          forms: updatedForms,
          groupSuccessMessage: "Group successfully removed.",
          isDeletingAll: false,
        },
        () => {
          setTimeout(() => {
            window.$("#modalDeleteAlert").modal("hide");
          }, 2000);
        },
      );

      setTimeout(() => {
        this.setState({
          groupErrorMessage: "",
          groupSuccessMessage: "",
        });
      }, 2000);
    }, 1000);
  };

  deleteGroup = () => {
    const { groups, forms, delete_group } = this.state;

    const groupToDelete = groups[delete_group];
    if (!groupToDelete) {
      this.setState({
        groupErrorMessage: "Group not found.",
        isDeleting: false,
      });
      return;
    }

    const questionIdsToDelete = groupToDelete.questions;
    const deletedSeq = parseInt(groupToDelete.sequenceNumber);

    const updatedGroups = groups
      .filter((_, i) => i !== delete_group)
      .map((g) => {
        const gSeq = parseInt(g.sequenceNumber);
        return !isNaN(deletedSeq) && !isNaN(gSeq) && gSeq > deletedSeq
          ? { ...g, sequenceNumber: String(gSeq - 1) }
          : g;
      });

    const updatedForms = forms.map((form) => {
      if (!form.questions) return form;

      const filteredQuestions = form.questions.filter(
        (question) => !questionIdsToDelete.includes(question.id),
      );

      return { ...form, questions: filteredQuestions };
    });

    this.setState({ isDeleting: true });

    setTimeout(() => {
      this.setState(
        {
          groups: updatedGroups,
          //forms: updatedForms,
          groupSuccessMessage: "Group successfully removed.",
          isDeleting: false,
        },
        () => {
          setTimeout(() => {
            window.$("#modalDeleteAlert").modal("hide");
          }, 2000);
        },
      );

      setTimeout(() => {
        this.setState({
          groupErrorMessage: "",
          groupSuccessMessage: "",
        });
      }, 2000);
    }, 1000);
  };

  closeDelForm = async () => {
    this.setState({
      delete_form_acc: "",
    });
    window.$("#modalDeleteAlert").modal("hide");
  };

  handleMaxLengthChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, maxLength: value }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleTextOnlyChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, textOnly: value }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleGroupTooltipChange = (event) => {
    this.setState((prevState) => ({
      currentGroup: {
        ...prevState.currentGroup,
        group_instructions: event.target.value,
      },
    }));
  };

  handleTextTypeChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, textType: value }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleInputFormatChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, inputFormat: value, options: [] }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleInputFormat = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, inputFormat: value, options: [] }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleMaxLengthChange_new = (questionId, event) => {
    const newMaxLength = event.target.value;
    //console.log("maxLength: ", newMaxLength);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, maxLength: newMaxLength, options: [] };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleTextOnlyChange_new = (questionId, event) => {
    const newMaxLength = event.target.value;
    //console.log("maxLength: ", newMaxLength);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, textOnly: newMaxLength, options: [] };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleTextOnlyRichChange = (formId, questionId, value) => {
    this.setState((prevState) => ({
      forms: prevState.forms.map((form) =>
        form.id === formId
          ? {
              ...form,
              questions: form.questions.map((question) =>
                question.id === questionId
                  ? { ...question, textOnly: value }
                  : question,
              ),
            }
          : form,
      ),
    }));
  };

  handleTextOnlyRichChange_new = (questionId, value) => {
    this.setState((prevState) => {
      const updatedQuestions = prevState.newQuestion.map((question) => {
        if (question.id === questionId) {
          return { ...question, textOnly: value, options: [] };
        }
        return question;
      });

      return { newQuestion: updatedQuestions };
    });
  };

  handleTextTypeChange_new = (questionId, event) => {
    const newMaxLength = event.target.value;
    //console.log("maxLength: ", newMaxLength);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, textType: newMaxLength, options: [] };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleInputFormatChange_new = (questionId, event) => {
    const newInputFormat = event.target.value;
    //console.log("inputFormat: ", newInputFormat);
    this.setState(
      (prevState) => {
        const updatedQuestions = prevState.newQuestion.map((question) => {
          if (question.id === questionId) {
            return { ...question, inputFormat: newInputFormat, options: [] };
          }
          return question;
        });

        return { newQuestion: updatedQuestions };
      },
      () => {
        // Callback function to log the state after it has been updated
        //console.log("Updated newQuestion state:", this.state.newQuestion);
      },
    );
  };

  handleAllowAIQuestionChange = (e) => {
    this.setState({ allowAIQuestion: e.target.checked });
  };

  handleAllowAIChange = (formId, questionId, value) => {
    this.setState((prevState) => {
      const updatedForms = prevState.forms.map((form) => {
        if (form.id === formId) {
          return {
            ...form,
            questions: form.questions.map((q) =>
              q.id === questionId ? { ...q, allowAI: value ? 1 : 0 } : q,
            ),
          };
        }
        return form;
      });
      return { forms: updatedForms };
    });
  };

  render() {
    const { classes, link_form, for_bcid, account_creation, is_sipnav } = this.props;
    const { forms } = this.state;
    return (
      <div>
        {link_form === false ? (
          <>
            <div className="example-alert mb-4">
              <div className="alert alert-gray alert-icon">
                <em className="icon ni ni-alert-circle"></em>{" "}
                <strong>
                  Note: Please "Save Form" regularly to protect your data as you
                  add groups or questions. Avoid refreshing the page without
                  saving your changes. {link_form}
                </strong>
              </div>
            </div>
            <div className="border-bottom mb-4 pb-4">
              <div className="nk-block-between-md g-4">
                <div className="nk-block-head-content">
                  <h3 className="nk-block-title fw-normal">Groups</h3>
                </div>
                <div className="nk-block-head-content">
                  <ul className="nk-block-tools gx-3">
                    <li className="order-md-last">
                      <a
                        onClick={() => this.addGroup()}
                        className="btn btn-primary"
                        style={{ color: "#fff", cursor: "pointer" }}
                      >
                        <em className="icon ni ni-plus"></em>
                        <span>Add New Group</span>
                      </a>
                    </li>
                    {forms.map((form, idx) => (
                      <li className="order-md-last" key={`f1-${idx}`}>
                        <a
                          style={{ cursor: "pointer", color: "#fff" }}
                          onClick={() => this.addNewQuestion(form.id)}
                          className={`btn btn-primary`}
                        >
                          <em className="icon ni ni-plus"></em>
                          <span>Add New Question</span>
                        </a>
                      </li>
                    ))}
                    <li className="order-md-last">
                      <a
                        style={{ cursor: "pointer", color: "#fff" }}
                        onClick={this.handleSaveForm}
                        className="btn btn-success"
                      >
                        <em className="icon ni ni-save"></em> &nbsp;Save Form
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {this.state.groups && this.state.groups.length > 0 ? (
                <div id="accordion" className="accordion mt-4">
                  {Array.isArray(this.state.groups) &&
                    this.state.groups.map((group, index) => (
                      <div className="accordion-item" key={`group_${index}`}>
                        <a
                          className={
                            index === 0
                              ? "accordion-head"
                              : "accordion-head collapsed"
                          }
                          data-toggle="collapse"
                          data-target={`#accordion-items-${index}`}
                          style={{
                            backgroundColor: "#f5f6fa",
                            cursor: "pointer",
                          }}
                        >
                          <h6 className="title">
                            {group.sequenceNumber}. {group.group_title}{" "}
                            <span className="badge badge-dim badge-primary badge-pill">
                              <em
                                className="icon ni ni-edit"
                                style={{ cursor: "pointer", fontSize: "16px" }}
                                //onClick={() => this.editGroupNew(index)}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.editGroupNew(index);
                                }}
                              ></em>
                            </span>
                            <span className="badge badge-dim badge-danger badge-pill">
                              <em
                                className="icon ni ni-trash"
                                style={{ cursor: "pointer", fontSize: "16px" }}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.openDelForm(index);
                                }}
                              ></em>
                            </span>
                          </h6>
                          <span className="accordion-icon"></span>
                        </a>
                        <div
                          className={
                            index === 0
                              ? "accordion-body collapse show"
                              : "accordion-body collapse"
                          }
                          id={`accordion-items-${index}`}
                          data-parent="#accordion"
                        >
                          <div className="accordion-inner">
                            <strong style={{ color: "#1c2b46" }}>
                              Assigned Fields
                            </strong>

                            <div className="mt-4">
                              {forms.map((form, findex) => (
                                <div
                                  key={`form_keys_${findex}`}
                                  className={classes.formContainer}
                                >
                                  {form.questions.map((question, indexes) => (
                                    <>
                                      {this.checkIfIdExists(
                                        group.questions,
                                        question.id,
                                      ) && (
                                        <div
                                          key={`input_key_${indexes}`}
                                          className={classes.questionContainer}
                                        >
                                          <div
                                            className={`row g-4 ${classes.questionTop}`}
                                          >
                                            <div className="col-lg-1">
                                              <MutextField
                                                label="Seq #"
                                                value={
                                                  question.sequenceNumber &&
                                                  question.sequenceNumber !== ""
                                                    ? question.sequenceNumber
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  this.handleSequenceChange(
                                                    form.id,
                                                    question.id,
                                                    e.target.value,
                                                  )
                                                }
                                                onInput={(e) => {
                                                  e.target.value =
                                                    e.target.value.replace(
                                                      /\D/g,
                                                      "",
                                                    );
                                                }}
                                                inputProps={{ maxLength: 3 }}
                                                variant="outlined"
                                                fullWidth
                                              />
                                            </div>
                                            <div className="col-lg-9">
                                              <div className="form-group">
                                                <MutextField
                                                  label="Question Text *"
                                                  value={question.questionText}
                                                  onChange={(e) =>
                                                    this.handleQuestionTextChange(
                                                      form.id,
                                                      question.id,
                                                      e.target.value,
                                                    )
                                                  }
                                                  variant="outlined"
                                                  fullWidth
                                                />
                                              </div>
                                            </div>
                                            <div className="col-lg-2">
                                              <div className="form-group">
                                                <MutextField
                                                  id={`answer-type-label-${question.id}`}
                                                  name={`answer-type-label-${question.id}`}
                                                  select
                                                  label="Answer Type *"
                                                  value={question.answerType}
                                                  onChange={(e) =>
                                                    this.handleAnswerTypeChange(
                                                      form.id,
                                                      question.id,
                                                      e.target.value,
                                                    )
                                                  }
                                                  SelectProps={{
                                                    native: true,
                                                  }}
                                                  variant="outlined"
                                                  fullWidth
                                                >
                                                  <option
                                                    key=""
                                                    value=""
                                                  ></option>
                                                  <option
                                                    key="input"
                                                    value="input"
                                                  >
                                                    Input
                                                  </option>
                                                  <option
                                                    key="textarea"
                                                    value="textarea"
                                                  >
                                                    Textarea
                                                  </option>
                                                  <option
                                                    key="dropdown"
                                                    value="dropdown"
                                                  >
                                                    Dropdown
                                                  </option>
                                                  <option
                                                    key="input2"
                                                    value="label"
                                                  >
                                                    Label
                                                  </option>
                                                  <option
                                                    key="text_only"
                                                    value="text_only"
                                                  >
                                                    Plain Text
                                                  </option>
                                                  <option
                                                    key="rich_text"
                                                    value="rich_text"
                                                  >
                                                    Rich Text
                                                  </option>
                                                  <option
                                                    key="notice_text"
                                                    value="notice_text"
                                                  >
                                                    Notice Text
                                                  </option>
                                                  <option
                                                    key="warning_text"
                                                    value="warning_text"
                                                  >
                                                    Warning Text
                                                  </option>
                                                  <option
                                                    key="input"
                                                    value="fixed"
                                                  >
                                                    Fixed Fields
                                                  </option>
                                                  <option
                                                    key="input"
                                                    value="signature"
                                                  >
                                                    Signature
                                                  </option>
                                                  <option
                                                    key="checkbox"
                                                    value="checkbox"
                                                  >
                                                    Checkbox
                                                  </option>
                                                  <option
                                                    key="radio"
                                                    value="radio"
                                                  >
                                                    Radio
                                                  </option>
                                                  <option
                                                    key="image_input"
                                                    value="image_input"
                                                  >
                                                    Image Input
                                                  </option>
                                                  <option
                                                    key="datetime"
                                                    value="datetime"
                                                  >
                                                    Datetime
                                                  </option>
                                                  <option
                                                    key="date"
                                                    value="date"
                                                  >
                                                    Date
                                                  </option>
                                                  <option
                                                    key="time"
                                                    value="time"
                                                  >
                                                    Time
                                                  </option>
                                                </MutextField>
                                              </div>
                                            </div>
                                            {!this.isStaticTextAnswerType(
                                              question.answerType,
                                            ) && (
                                              <div className="col-lg-12">
                                                <div className="form-group">
                                                  <div className="form-control-wrap">
                                                    <MutextField
                                                      label="Tooltip / Help Text"
                                                      value={question.tooltip}
                                                      onChange={(e) =>
                                                        this.handleTooltipChange(
                                                          form.id,
                                                          question.id,
                                                          e.target.value,
                                                        )
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                            {!this.isStaticTextAnswerType(
                                              question.answerType,
                                            ) && (
                                              <div className="col-lg-12">
                                                <div className="form-group">
                                                  <div className="form-control-wrap">
                                                    <MutextField
                                                      label="Default Value"
                                                      value={
                                                        question.defaultValue
                                                      }
                                                      onChange={(e) =>
                                                        this.handleDefaultValueChange(
                                                          form.id,
                                                          question.id,
                                                          e.target.value,
                                                        )
                                                      }
                                                      variant="outlined"
                                                      fullWidth
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                            {!this.isStaticTextAnswerType(
                                              question.answerType,
                                            ) ? (
                                              <div className="col-lg-2">
                                                <div className="form-group">
                                                  <MutextField
                                                    id={`validation-value-label-${question.id}`}
                                                    name={`validation-value-label-${question.id}`}
                                                    select
                                                    label="Validation"
                                                    value={
                                                      question.validationValue
                                                    }
                                                    onChange={(e) =>
                                                      this.handleValidationValueChange(
                                                        form.id,
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    SelectProps={{
                                                      native: true,
                                                    }}
                                                    variant="outlined"
                                                    fullWidth
                                                  >
                                                    <option
                                                      key=""
                                                      value=""
                                                    ></option>
                                                    <option
                                                      key="validation_email"
                                                      value="validation_email"
                                                    >
                                                      Email Address
                                                    </option>
                                                    {/* <option
                                                      key="validation_fulladdress"
                                                      value="validation_fulladdress"
                                                    >
                                                      Full Address
                                                    </option> */}
                                                    <option
                                                      key="validation_phone"
                                                      value="validation_phone"
                                                    >
                                                      Phone Number
                                                    </option>
                                                    <option
                                                      key="validation_ips"
                                                      value="validation_ip"
                                                    >
                                                      IP Address
                                                    </option>
                                                      {/* <option
                                                        key="validation_filerId"
                                                        value="validation_filerId"
                                                      >
                                                        FCC 499 Filer
                                                      </option> */}
                                                    <option
                                                      key="validation_address"
                                                      value="validation_address"
                                                    >
                                                      Address
                                                    </option>
                                                    <option
                                                      key="validation_city"
                                                      value="validation_city"
                                                    >
                                                      City
                                                    </option>
                                                    <option
                                                      key="validation_state"
                                                      value="validation_state"
                                                    >
                                                      State
                                                    </option>
                                                    <option
                                                      key="validation_zip"
                                                      value="validation_zip"
                                                    >
                                                      Zip
                                                    </option>
                                                    <option
                                                      key="validation_country"
                                                      value="validation_country"
                                                    >
                                                      Country
                                                    </option>
                                                  </MutextField>
                                                </div>
                                              </div>
                                            ) : null}
                                            {question.answerType === "input" ||
                                            question.answerType ===
                                              "textarea" ? (
                                              <div className="col-lg-2">
                                                <div className="form-group">
                                                  <MutextField
                                                    label="Max Length"
                                                    value={question.maxLength}
                                                    onChange={(e) => {
                                                      const value =
                                                        e.target.value;
                                                      if (
                                                        /^\d*$/.test(value) &&
                                                        value.length <= 3
                                                      ) {
                                                        // Allow only digits and a max length of 3
                                                        this.handleMaxLengthChange(
                                                          form.id,
                                                          question.id,
                                                          value,
                                                        );
                                                      }
                                                    }}
                                                    onKeyPress={(e) => {
                                                      if (
                                                        (!/[0-9]/.test(e.key) &&
                                                          e.key !==
                                                            "Backspace" &&
                                                          e.key !== "Delete") ||
                                                        (e.target.value
                                                          .length >= 3 &&
                                                          /[0-9]/.test(e.key))
                                                      ) {
                                                        e.preventDefault();
                                                      }
                                                    }}
                                                    variant="outlined"
                                                    fullWidth
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {question.answerType === "input" ||
                                            question.answerType ===
                                              "textarea" ? (
                                              <div className="col-lg-2">
                                                <div className="form-group">
                                                  <MutextField
                                                    id={`input-format-${question.id}`}
                                                    name={`input-format--${question.id}`}
                                                    select
                                                    label="Input Format"
                                                    value={question.inputFormat}
                                                    onChange={(e) =>
                                                      this.handleInputFormatChange(
                                                        form.id,
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    SelectProps={{
                                                      native: true,
                                                    }}
                                                    variant="outlined"
                                                    fullWidth
                                                  >
                                                    <option
                                                      key=""
                                                      value=""
                                                    ></option>
                                                    <option
                                                      key="number_only"
                                                      value="number_only"
                                                    >
                                                      Number Only
                                                    </option>
                                                    <option
                                                      key="alphabet_only"
                                                      value="alphabet_only"
                                                    >
                                                      Alphabet Only
                                                    </option>
                                                    <option
                                                      key="alphanumeric"
                                                      value="alphanumeric"
                                                    >
                                                      Alphanumeric
                                                    </option>
                                                    <option
                                                      key="open"
                                                      value="open"
                                                    >
                                                      Open (No Restrictions)
                                                    </option>
                                                  </MutextField>
                                                </div>
                                              </div>
                                            ) : null}
                                            {!this.isStaticTextAnswerType(
                                              question.answerType,
                                            ) ? (
                                              <div className="col-lg-2">
                                                <div className="form-group">
                                                  <MutextField
                                                    id={`dynamic-value-${question.id}`}
                                                    name={`dynamic-value-${question.id}`}
                                                    select
                                                    label="Dynamic Value"
                                                    value={
                                                      question.dynamicValue
                                                    }
                                                    onChange={(e) =>
                                                      this.handleDynamicValue(
                                                        form.id,
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    SelectProps={{
                                                      native: true,
                                                    }}
                                                    variant="outlined"
                                                    fullWidth
                                                  >
                                                    <option
                                                      key=""
                                                      value=""
                                                    ></option>
                                                    <option
                                                      key="fullname"
                                                      value="fullname"
                                                    >
                                                      Full Name
                                                    </option>
                                                    <option
                                                      key="company"
                                                      value="company"
                                                    >
                                                      Company
                                                    </option>
                                                    <option
                                                      key="email"
                                                      value="email"
                                                    >
                                                      Email Address
                                                    </option>
                                                    <option
                                                      key="phone"
                                                      value="phone"
                                                    >
                                                      Phone
                                                    </option>
                                                    <option
                                                      key="full_address"
                                                      value="full_address"
                                                    >
                                                      Full Address
                                                    </option>
                                                    <option
                                                      key="address"
                                                      value="address"
                                                    >
                                                      Address
                                                    </option>
                                                    <option
                                                      key="appartment"
                                                      value="appartment"
                                                    >
                                                      Appartment, Suite
                                                    </option>
                                                    <option
                                                      key="city"
                                                      value="city"
                                                    >
                                                      City
                                                    </option>
                                                    <option
                                                      key="state"
                                                      value="state"
                                                    >
                                                      State
                                                    </option>
                                                    <option
                                                      key="zip"
                                                      value="zip"
                                                    >
                                                      Zip
                                                    </option>
                                                    <option
                                                      key="country"
                                                      value="country"
                                                    >
                                                      Country
                                                    </option>
                                                    {this.state.is_fcc_enabled === "Yes" ? (
                                                      <>
                                                        <optgroup label="FCC - Robocall Data">
                                                          <option key="fcc_rb_number" value="fcc.robocall_data.number">Number</option>
                                                          <option key="fcc_rb_frn" value="fcc.robocall_data.frn">FRN</option>
                                                          <option key="fcc_rb_business_name" value="fcc.robocall_data.business_name">Business Name</option>
                                                          <option key="fcc_rb_business_address" value="fcc.robocall_data.business_address">Business Address</option>
                                                          <option key="fcc_rb_country" value="fcc.robocall_data.country">Country</option>
                                                          <option key="fcc_rb_contact_name" value="fcc.robocall_data.robocall_mitigation_contact_name">Contact Name</option>
                                                          <option key="fcc_rb_contact_title" value="fcc.robocall_data.contact_title">Contact Title</option>
                                                          <option key="fcc_rb_contact_department" value="fcc.robocall_data.contact_department">Contact Department</option>
                                                          <option key="fcc_rb_contact_business_address" value="fcc.robocall_data.contact_business_address">Contact Business Address</option>
                                                          <option key="fcc_rb_contact_country" value="fcc.robocall_data.contact_country">Contact Country</option>
                                                          <option key="fcc_rb_contact_telephone" value="fcc.robocall_data.contact_telephone_number">Contact Telephone</option>
                                                          <option key="fcc_rb_contact_email" value="fcc.robocall_data.contact_email">Contact Email</option>
                                                          <option key="fcc_rb_filing_url" value="fcc.robocall_data.filing_url">Filing URL</option>
                                                          <option key="fcc_rb_ocn" value="fcc.robocall_data.ocn">OCN</option>
                                                          <option key="fcc_rb_holding_company" value="fcc.robocall_data.holding_company">Holding Company</option>
                                                        </optgroup>
                                                        <optgroup label="FCC - 499 Filer Data">
                                                          <option key="fcc_499_filer_id" value="fcc.499_filer_data.filer_499_id">Filer 499 ID</option>
                                                          <option key="fcc_499_lastfiling" value="fcc.499_filer_data.lastfiling">Last Filing</option>
                                                          <option key="fcc_499_legal_name" value="fcc.499_filer_data.legal_name_of_carrier">Legal Name of Carrier</option>
                                                          <option key="fcc_499_comm_type" value="fcc.499_filer_data.principal_comm_type_1">Principal Comm Type</option>
                                                          <option key="fcc_499_holding" value="fcc.499_filer_data.holding_company">Holding Company</option>
                                                          <option key="fcc_499_hq_addr1" value="fcc.499_filer_data.hq_address1">HQ Address 1</option>
                                                          <option key="fcc_499_hq_addr2" value="fcc.499_filer_data.hq_address2">HQ Address 2</option>
                                                          <option key="fcc_499_hq_city" value="fcc.499_filer_data.hq_city">HQ City</option>
                                                          <option key="fcc_499_hq_state" value="fcc.499_filer_data.hq_state">HQ State</option>
                                                          <option key="fcc_499_hq_zip" value="fcc.499_filer_data.hq_zip_code">HQ Zip Code</option>
                                                          <option key="fcc_499_ci_addr1" value="fcc.499_filer_data.customer_inquiries_address1">Customer Inquiries Address 1</option>
                                                          <option key="fcc_499_ci_addr2" value="fcc.499_filer_data.customer_inquiries_address2">Customer Inquiries Address 2</option>
                                                          <option key="fcc_499_ci_addr3" value="fcc.499_filer_data.customer_inquiries_address3">Customer Inquiries Address 3</option>
                                                          <option key="fcc_499_ci_city" value="fcc.499_filer_data.customer_inquiries_city">Customer Inquiries City</option>
                                                          <option key="fcc_499_ci_state" value="fcc.499_filer_data.customer_inquiries_state">Customer Inquiries State</option>
                                                          <option key="fcc_499_ci_zip" value="fcc.499_filer_data.customer_inquiries_zip_code">Customer Inquiries Zip</option>
                                                          <option key="fcc_499_ci_tel" value="fcc.499_filer_data.customer_inquiries_telephone">Customer Inquiries Telephone</option>
                                                          <option key="fcc_499_trade1" value="fcc.499_filer_data.other_trade_name1">Other Trade Name 1</option>
                                                          <option key="fcc_499_trade2" value="fcc.499_filer_data.other_trade_name2">Other Trade Name 2</option>
                                                          <option key="fcc_499_dc1" value="fcc.499_filer_data.dc_agent1">DC Agent 1</option>
                                                          <option key="fcc_499_dc2" value="fcc.499_filer_data.dc_agent2">DC Agent 2</option>
                                                          <option key="fcc_499_dc_tel" value="fcc.499_filer_data.dc_agent_telephone">DC Agent Telephone</option>
                                                          <option key="fcc_499_dc_fax" value="fcc.499_filer_data.dc_agent_fax">DC Agent Fax</option>
                                                          <option key="fcc_499_dc_email" value="fcc.499_filer_data.dc_agent_email">DC Agent Email</option>
                                                          <option key="fcc_499_dc_addr1" value="fcc.499_filer_data.dc_agent_address1">DC Agent Address 1</option>
                                                          <option key="fcc_499_dc_addr2" value="fcc.499_filer_data.dc_agent_address2">DC Agent Address 2</option>
                                                          <option key="fcc_499_dc_addr3" value="fcc.499_filer_data.dc_agent_address3">DC Agent Address 3</option>
                                                          <option key="fcc_499_dc_city" value="fcc.499_filer_data.dc_agent_city">DC Agent City</option>
                                                          <option key="fcc_499_dc_state" value="fcc.499_filer_data.dc_agent_state">DC Agent State</option>
                                                          <option key="fcc_499_dc_zip" value="fcc.499_filer_data.dc_agent_zip">DC Agent Zip</option>
                                                          <option key="fcc_499_alt1" value="fcc.499_filer_data.alternate_agent1">Alternate Agent 1</option>
                                                          <option key="fcc_499_alt2" value="fcc.499_filer_data.alternate_agent2">Alternate Agent 2</option>
                                                          <option key="fcc_499_alt_tel" value="fcc.499_filer_data.alternate_agent_telephone">Alternate Agent Telephone</option>
                                                          <option key="fcc_499_alt_fax" value="fcc.499_filer_data.alternate_agent_fax">Alternate Agent Fax</option>
                                                          <option key="fcc_499_alt_email" value="fcc.499_filer_data.alternate_agent_email">Alternate Agent Email</option>
                                                          <option key="fcc_499_alt_addr1" value="fcc.499_filer_data.alternate_agent_address1">Alternate Agent Address 1</option>
                                                          <option key="fcc_499_alt_addr2" value="fcc.499_filer_data.alternate_agent_address2">Alternate Agent Address 2</option>
                                                          <option key="fcc_499_alt_addr3" value="fcc.499_filer_data.alternate_agent_address3">Alternate Agent Address 3</option>
                                                          <option key="fcc_499_alt_city" value="fcc.499_filer_data.alternate_agent_city">Alternate Agent City</option>
                                                          <option key="fcc_499_alt_state" value="fcc.499_filer_data.alternate_agent_state">Alternate Agent State</option>
                                                          <option key="fcc_499_alt_zip" value="fcc.499_filer_data.alternate_agent_zip_code">Alternate Agent Zip</option>
                                                        </optgroup>
                                                      </>
                                                    ) : null}
                                                    {this.state.is_outbound_sbc_enabled === "Yes" && is_sipnav ? (
                                                      <optgroup label="Outbound SBC Configuration">
                                                        <option key="sipnav_cps_limit" value="sipnav.cps_limit">CPS Limit</option>
                                                        <option key="sipnav_session_limit" value="sipnav.session_limit">Session Limit</option>
                                                        <option key="sipnav_ring_time" value="sipnav.ring_time">Ring Time</option>
                                                        <option key="sipnav_no_call_progress" value="sipnav.no_call_progress">No Call Progress</option>
                                                        <option key="sipnav_enforce_cid_block" value="sipnav.enforce_cid_block">Enforce CID Block</option>
                                                        <option key="sipnav_cid_block_min_asr" value="sipnav.cid_block_min_asr">CID Block Min ASR</option>
                                                        <option key="sipnav_cid_block_min_acd" value="sipnav.cid_block_min_acd">CID Block Min ACD</option>
                                                        <option key="sipnav_cid_block_max_sdp" value="sipnav.cid_block_max_sdp">CID Block Max SDP</option>
                                                        <option key="sipnav_international_calls" value="sipnav.international_calls">International Calls</option>
                                                        <option key="sipnav_block_wireless" value="sipnav.block_wireless">Block Wireless</option>
                                                        <option key="sipnav_block_dnc" value="sipnav.block_dnc">Block DNC</option>
                                                        <option key="sipnav_remove_cid_name" value="sipnav.remove_cid_name">Remove CID Name</option>
                                                        <option key="sipnav_disable_call_restrictions" value="sipnav.disable_call_restrictions">Disable Call Restrictions</option>
                                                        <option key="sipnav_ani_blacklist" value="sipnav.ani_blacklist">ANI Blacklist</option>
                                                        <option key="sipnav_dnis_blacklist" value="sipnav.dnis_blacklist">DNIS Blacklist</option>
                                                      </optgroup>
                                                    ) : null}
                                                  </MutextField>
                                                </div>
                                              </div>
                                            ) : null}
                                            {account_creation === true &&
                                            question.answerType === "input" ? (
                                              <div className="col-lg-2">
                                                <div className="form-group">
                                                  <MutextField
                                                    id={`create-account-${question.id}`}
                                                    name={`create-account-${question.id}`}
                                                    select
                                                    label="Select Value for Account Creation"
                                                    value={
                                                      question.createAccount
                                                    }
                                                    onChange={(e) =>
                                                      this.handleCreateAccount(
                                                        form.id,
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    SelectProps={{
                                                      native: true,
                                                    }}
                                                    variant="outlined"
                                                    fullWidth
                                                  >
                                                    {this.state.accountCreationOptions.map(
                                                      (option) => (
                                                        <option
                                                          key={`opt-1${option.value}`}
                                                          value={option.value}
                                                          disabled={
                                                            option.disabled ||
                                                            false
                                                          }
                                                        >
                                                          {option.label}
                                                        </option>
                                                      ),
                                                    )}
                                                  </MutextField>
                                                </div>
                                              </div>
                                            ) : null}
                                            {!this.isStaticTextAnswerType(
                                              question.answerType,
                                            ) ? (
                                              <div className="col-lg-2">
                                                <div className="form-group">
                                                  <MutextField
                                                    id={`required-label-${question.id}`}
                                                    name={`required-label-${question.id}`}
                                                    select
                                                    label="Required"
                                                    value={question.required.toString()}
                                                    onChange={(e) =>
                                                      this.handleRequiredChange(
                                                        form.id,
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    SelectProps={{
                                                      native: true,
                                                    }}
                                                    variant="outlined"
                                                    fullWidth
                                                  >
                                                    <option
                                                      key="false"
                                                      value="false"
                                                    >
                                                      No
                                                    </option>
                                                    <option
                                                      key="true"
                                                      value="true"
                                                    >
                                                      Yes
                                                    </option>
                                                  </MutextField>
                                                </div>
                                              </div>
                                            ) : null}
                                            {(question.answerType === "input" ||
                                              question.answerType ===
                                                "textarea") &&
                                              this.state.chatgpt_intergation ===
                                                "Yes" && ( // 👈 added condition
                                                <div className="col-lg-2 d-flex align-items-center">
                                                  <label
                                                    className="form-label mb-0"
                                                    style={{
                                                      marginRight: "10px",
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    AI Assistance
                                                  </label>
                                                  <div className="custom-control custom-switch">
                                                    <input
                                                      type="checkbox"
                                                      className="custom-control-input"
                                                      id={`allow-ai-${question.id}`}
                                                      checked={
                                                        !!question.allowAI
                                                      }
                                                      onChange={(e) =>
                                                        this.handleAllowAIChange(
                                                          form.id,
                                                          question.id,
                                                          e.target.checked,
                                                        )
                                                      }
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor={`allow-ai-${question.id}`}
                                                    ></label>
                                                  </div>
                                                </div>
                                              )}

                                            <div
                                              className="col-lg-5"
                                              style={{
                                                alignContent: "center",
                                                display: "flex",
                                              }}
                                            >
                                              {question.answerType !==
                                              "image_input" ? (
                                                <div
                                                  style={{
                                                    alignContent: "center",
                                                  }}
                                                >
                                                  <input
                                                    id={`image-upload-${question.id}`}
                                                    type="file"
                                                    accept=".png, .jpg, .jpeg, .pdf, .txt, .csv, .xls, .xlsx, .doc, .docx"
                                                    style={{ display: "none" }}
                                                    onChange={(e) =>
                                                      this.handleImageUpload(
                                                        form.id,
                                                        question.id,
                                                        e,
                                                      )
                                                    }
                                                  />
                                                  <button
                                                    className={`btn btn-dim btn-primary ${classes.deleteButton}`}
                                                    onClick={() => {
                                                      const fileInput =
                                                        document.getElementById(
                                                          `image-upload-${question.id}`,
                                                        );
                                                      if (fileInput) {
                                                        fileInput.click();
                                                      }
                                                    }}
                                                  >
                                                    Upload File
                                                  </button>
                                                </div>
                                              ) : null}
                                              <div
                                                className=""
                                                style={{
                                                  alignContent: "center",
                                                }}
                                              >
                                                <a
                                                  className={`btn btn-dim btn-danger ${classes.deleteButton}`}
                                                  onClick={() =>
                                                    this.handleDeleteQuestion(
                                                      form.id,
                                                      question.id,
                                                    )
                                                  }
                                                >
                                                  Delete
                                                </a>
                                              </div>
                                            </div>
                                            {question.imageUrl && (
                                              <div className="col-lg-12 text-primary">
                                                {question.imageUrl}
                                              </div>
                                            )}
                                            {question.answerType ===
                                              "checkbox" ||
                                            question.answerType === "radio" ||
                                            question.answerType ===
                                              "dropdown" ? (
                                              <div className="col-lg-6">
                                                {question.options.map(
                                                  (option, index) => (
                                                    <div
                                                      key={`rad-1-${index}`}
                                                      className={
                                                        classes.optionContainer
                                                      }
                                                    >
                                                      <MutextField
                                                        label={`Option ${
                                                          index + 1
                                                        }`}
                                                        value={option}
                                                        onChange={(e) =>
                                                          this.handleOptionChange(
                                                            form.id,
                                                            question.id,
                                                            index,
                                                            e.target.value,
                                                          )
                                                        }
                                                        variant="outlined"
                                                        fullWidth
                                                      />
                                                      <a
                                                        className={`btn btn-dim btn-danger ${classes.deleteButton}`}
                                                        onClick={() =>
                                                          this.handleDeleteOption(
                                                            form.id,
                                                            question.id,
                                                            index,
                                                          )
                                                        }
                                                      >
                                                        Delete
                                                      </a>
                                                    </div>
                                                  ),
                                                )}
                                                <a
                                                  className={`btn btn-outline-light`}
                                                  onClick={() =>
                                                    this.handleAddOption(
                                                      form.id,
                                                      question.id,
                                                    )
                                                  }
                                                  style={{ marginTop: "20px" }}
                                                >
                                                  Add Option
                                                </a>
                                              </div>
                                            ) : null}
                                            {question.answerType ===
                                            "image_input" ? (
                                              <div className="col-lg-4">
                                                <input
                                                  type="file"
                                                  accept="image/*"
                                                  disabled
                                                />
                                              </div>
                                            ) : null}
                                            {question.answerType === "fixed" ? (
                                              <div className="col-lg-7">
                                                <div className="form-group">
                                                  <MutextField
                                                    label="Value"
                                                    value={question.answer}
                                                    onChange={(e) =>
                                                      this.handleFixedOption(
                                                        form.id,
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    variant="outlined"
                                                    fullWidth
                                                  />
                                                </div>
                                              </div>
                                            ) : null}
                                            {question.answerType ===
                                            "text_only" ? (
                                              <>
                                                <div className="col-lg-12">
                                                  <div className="form-group">
                                                    <MutextField
                                                      id={`textType-${question.id}`}
                                                      name={`textType-${question.id}`}
                                                      select
                                                      label="Text Type"
                                                      value={
                                                        question.textType || "p"
                                                      }
                                                      onChange={(e) =>
                                                        this.handleTextTypeChange(
                                                          form.id,
                                                          question.id,
                                                          e.target.value,
                                                        )
                                                      }
                                                      SelectProps={{
                                                        native: true,
                                                      }}
                                                      variant="outlined"
                                                      fullWidth
                                                    >
                                                      <option
                                                        key="Paragraph1"
                                                        value="p"
                                                      >
                                                        Paragraph
                                                      </option>
                                                      <option
                                                        key="li1"
                                                        value="oli"
                                                      >
                                                        Ordered List
                                                      </option>
                                                      <option
                                                        key="li2"
                                                        value="sli"
                                                      >
                                                        Simple List
                                                      </option>
                                                    </MutextField>
                                                  </div>
                                                </div>

                                                <div className="col-lg-12">
                                                  <div className="form-group">
                                                    <label
                                                      className="form-label"
                                                      for="textOnly2"
                                                    >
                                                      Enter Text
                                                    </label>
                                                    <div className="form-control-wrap">
                                                      <textarea
                                                        className="form-control"
                                                        id="textOnly2"
                                                        name="textOnly"
                                                        maxLength={1000}
                                                        onChange={(e) => {
                                                          const value =
                                                            e.target.value;

                                                          // Allow only digits and a max length of 3
                                                          this.handleTextOnlyChange(
                                                            form.id,
                                                            question.id,
                                                            value,
                                                          );
                                                        }}
                                                        value={
                                                          question.textOnly
                                                        }
                                                      ></textarea>
                                                    </div>
                                                    <div
                                                      className="form-note"
                                                      style={{
                                                        marginTop: "8px",
                                                      }}
                                                    >
                                                      <b>Paragraph:</b> Write
                                                      free-form text. Use{" "}
                                                      <b>Enter</b> for new
                                                      lines. <br />
                                                      <b>
                                                        Ordered List:
                                                      </b> Press <b>Enter</b>{" "}
                                                      after each line to create
                                                      a numbered list. <br />
                                                      <b>
                                                        Simple List:
                                                      </b> Press <b>Enter</b>{" "}
                                                      after each line to create
                                                      a bulleted list. <br />
                                                      Maximum 5000 characters
                                                      are allowed.
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            ) : null}
                                            {this.isRichEditorAnswerType(
                                              question.answerType,
                                            ) ? (
                                              <div className="col-lg-12">
                                                <div className="form-group">
                                                  <label
                                                    className="form-label"
                                                    htmlFor={`textOnlyRich-${question.id}`}
                                                  >
                                                    Enter Content
                                                  </label>
                                                  <div className="form-control-wrap">
                                                    <RichTextEditorComponent
                                                      key={question.answerType}
                                                      answerType={question.answerType}
                                                      agreementContent={
                                                        question.textOnly || ""
                                                      }
                                                      onContentChange={(
                                                        updatedContent,
                                                      ) =>
                                                        this.handleTextOnlyRichChange(
                                                          form.id,
                                                          question.id,
                                                          updatedContent,
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  ))}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ) : null}
            </div>

            <h5 className="mt-4 mb-4">
              Form fields not assigned to the groups
            </h5>
            <div>
              {forms.map((form, foindex) => (
                <div
                  key={`form_key_${foindex}`}
                  className={`mt-4 ${classes.formContainer}`}
                >
                  {form.questions.map((question, indexes) => (
                    <>
                      {this.checkIfIdDoesNotExist(
                        this.state.groups,
                        question.id,
                      ) && (
                        <div
                          key={`input_key_1_${question.id}`}
                          className={classes.questionContainer}
                        >
                          <div className={`row g-4 ${classes.questionTop}`}>
                            <div className="col-lg-1">
                              <div className="nk-kycfm-count">
                                {indexes + 1}
                              </div>
                            </div>
                            <div className="col-lg-5">
                              <div className="form-group">
                                <MutextField
                                  label="Question Text"
                                  value={question.questionText}
                                  onChange={(e) =>
                                    this.handleQuestionTextChange(
                                      form.id,
                                      question.id,
                                      e.target.value,
                                    )
                                  }
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>
                            </div>
                            <div className="col-lg-2">
                              <div className="form-group">
                                <MutextField
                                  id={`answer-type-label-${question.id}`}
                                  name={`answer-type-label-${question.id}`}
                                  select
                                  label="Answer Type"
                                  value={question.answerType}
                                  onChange={(e) =>
                                    this.handleAnswerTypeChange(
                                      form.id,
                                      question.id,
                                      e.target.value,
                                    )
                                  }
                                  SelectProps={{
                                    native: true,
                                  }}
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="" value=""></option>
                                  <option key="input" value="input">
                                    Input
                                  </option>
                                  <option key="textarea" value="textarea">
                                    Textarea
                                  </option>
                                  <option key="dropdown" value="dropdown">
                                    Dropdown
                                  </option>
                                  <option key="input1" value="label">
                                    Label
                                  </option>
                                  <option key="text_only1" value="text_only">
                                    Plain Text
                                  </option>
                                  <option key="rich_text1" value="rich_text">
                                    Rich Text
                                  </option>
                                  <option
                                    key="notice_text1"
                                    value="notice_text"
                                  >
                                    Notice Text
                                  </option>
                                  <option
                                    key="warning_text1"
                                    value="warning_text"
                                  >
                                    Warning Text
                                  </option>
                                  <option key="input" value="fixed">
                                    Fixed Fields
                                  </option>
                                  <option key="input" value="signature">
                                    Signature
                                  </option>
                                  <option key="checkbox" value="checkbox">
                                    Checkbox
                                  </option>
                                  <option key="radio" value="radio">
                                    Radio
                                  </option>
                                  <option key="image_input" value="image_input">
                                    Image Input
                                  </option>
                                  <option key="datetime" value="datetime">
                                    Datetime
                                  </option>
                                  <option key="date" value="date">
                                    Date
                                  </option>
                                  <option key="time" value="time">
                                    Time
                                  </option>
                                </MutextField>
                              </div>
                            </div>
                            <div className="col-lg-2">
                              <div className="form-group">
                                <MutextField
                                  id={`dynamic-value-${question.id}`}
                                  name={`dynamic-value-${question.id}`}
                                  select
                                  label="Dynamic Value"
                                  value={question.dynamicValue}
                                  onChange={(e) =>
                                    this.handleDynamicValue(
                                      form.id,
                                      question.id,
                                      e.target.value,
                                    )
                                  }
                                  SelectProps={{
                                    native: true,
                                  }}
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="" value=""></option>
                                  <option key="fullname1" value="fullname">
                                    Full Name
                                  </option>
                                  <option key="company1" value="company">
                                    Company
                                  </option>
                                  <option key="email1" value="email">
                                    Email Address
                                  </option>
                                  <option key="phone1" value="phone">
                                    Phone
                                  </option>
                                  <option
                                    key="full_address1"
                                    value="full_address"
                                  >
                                    Full Address
                                  </option>
                                  <option key="address1" value="address">
                                    Address
                                  </option>
                                  <option key="appartment1" value="appartment">
                                    Appartment, Suite
                                  </option>
                                  <option key="city1" value="city">
                                    City
                                  </option>
                                  <option key="state1" value="state">
                                    State
                                  </option>
                                  <option key="zip1" value="zip">
                                    Zip
                                  </option>
                                  <option key="country1" value="country">
                                    Country
                                  </option>
                                  {this.state.is_fcc_enabled === "Yes" ? (
                                    <>
                                      <optgroup label="FCC - Robocall Data">
                                        <option key="fcc_rb_number1" value="fcc.robocall_data.number">Number</option>
                                        <option key="fcc_rb_frn1" value="fcc.robocall_data.frn">FRN</option>
                                        <option key="fcc_rb_business_name1" value="fcc.robocall_data.business_name">Business Name</option>
                                        <option key="fcc_rb_business_address1" value="fcc.robocall_data.business_address">Business Address</option>
                                        <option key="fcc_rb_country1" value="fcc.robocall_data.country">Country</option>
                                        <option key="fcc_rb_contact_name1" value="fcc.robocall_data.robocall_mitigation_contact_name">Contact Name</option>
                                        <option key="fcc_rb_contact_title1" value="fcc.robocall_data.contact_title">Contact Title</option>
                                        <option key="fcc_rb_contact_department1" value="fcc.robocall_data.contact_department">Contact Department</option>
                                        <option key="fcc_rb_contact_business_address1" value="fcc.robocall_data.contact_business_address">Contact Business Address</option>
                                        <option key="fcc_rb_contact_country1" value="fcc.robocall_data.contact_country">Contact Country</option>
                                        <option key="fcc_rb_contact_telephone1" value="fcc.robocall_data.contact_telephone_number">Contact Telephone</option>
                                        <option key="fcc_rb_contact_email1" value="fcc.robocall_data.contact_email">Contact Email</option>
                                        <option key="fcc_rb_filing_url1" value="fcc.robocall_data.filing_url">Filing URL</option>
                                        <option key="fcc_rb_ocn1" value="fcc.robocall_data.ocn">OCN</option>
                                        <option key="fcc_rb_holding_company1" value="fcc.robocall_data.holding_company">Holding Company</option>
                                      </optgroup>
                                      <optgroup label="FCC - 499 Filer Data">
                                        <option key="fcc_499_filer_id1" value="fcc.499_filer_data.filer_499_id">Filer 499 ID</option>
                                        <option key="fcc_499_lastfiling1" value="fcc.499_filer_data.lastfiling">Last Filing</option>
                                        <option key="fcc_499_legal_name1" value="fcc.499_filer_data.legal_name_of_carrier">Legal Name of Carrier</option>
                                        <option key="fcc_499_comm_type1" value="fcc.499_filer_data.principal_comm_type_1">Principal Comm Type</option>
                                        <option key="fcc_499_holding1" value="fcc.499_filer_data.holding_company">Holding Company</option>
                                        <option key="fcc_499_hq_addr11" value="fcc.499_filer_data.hq_address1">HQ Address 1</option>
                                        <option key="fcc_499_hq_addr21" value="fcc.499_filer_data.hq_address2">HQ Address 2</option>
                                        <option key="fcc_499_hq_city1" value="fcc.499_filer_data.hq_city">HQ City</option>
                                        <option key="fcc_499_hq_state1" value="fcc.499_filer_data.hq_state">HQ State</option>
                                        <option key="fcc_499_hq_zip1" value="fcc.499_filer_data.hq_zip_code">HQ Zip Code</option>
                                        <option key="fcc_499_ci_addr11" value="fcc.499_filer_data.customer_inquiries_address1">Customer Inquiries Address 1</option>
                                        <option key="fcc_499_ci_addr21" value="fcc.499_filer_data.customer_inquiries_address2">Customer Inquiries Address 2</option>
                                        <option key="fcc_499_ci_addr31" value="fcc.499_filer_data.customer_inquiries_address3">Customer Inquiries Address 3</option>
                                        <option key="fcc_499_ci_city1" value="fcc.499_filer_data.customer_inquiries_city">Customer Inquiries City</option>
                                        <option key="fcc_499_ci_state1" value="fcc.499_filer_data.customer_inquiries_state">Customer Inquiries State</option>
                                        <option key="fcc_499_ci_zip1" value="fcc.499_filer_data.customer_inquiries_zip_code">Customer Inquiries Zip</option>
                                        <option key="fcc_499_ci_tel1" value="fcc.499_filer_data.customer_inquiries_telephone">Customer Inquiries Telephone</option>
                                        <option key="fcc_499_trade11" value="fcc.499_filer_data.other_trade_name1">Other Trade Name 1</option>
                                        <option key="fcc_499_trade21" value="fcc.499_filer_data.other_trade_name2">Other Trade Name 2</option>
                                        <option key="fcc_499_dc11" value="fcc.499_filer_data.dc_agent1">DC Agent 1</option>
                                        <option key="fcc_499_dc21" value="fcc.499_filer_data.dc_agent2">DC Agent 2</option>
                                        <option key="fcc_499_dc_tel1" value="fcc.499_filer_data.dc_agent_telephone">DC Agent Telephone</option>
                                        <option key="fcc_499_dc_fax1" value="fcc.499_filer_data.dc_agent_fax">DC Agent Fax</option>
                                        <option key="fcc_499_dc_email1" value="fcc.499_filer_data.dc_agent_email">DC Agent Email</option>
                                        <option key="fcc_499_dc_addr11" value="fcc.499_filer_data.dc_agent_address1">DC Agent Address 1</option>
                                        <option key="fcc_499_dc_addr21" value="fcc.499_filer_data.dc_agent_address2">DC Agent Address 2</option>
                                        <option key="fcc_499_dc_addr31" value="fcc.499_filer_data.dc_agent_address3">DC Agent Address 3</option>
                                        <option key="fcc_499_dc_city1" value="fcc.499_filer_data.dc_agent_city">DC Agent City</option>
                                        <option key="fcc_499_dc_state1" value="fcc.499_filer_data.dc_agent_state">DC Agent State</option>
                                        <option key="fcc_499_dc_zip1" value="fcc.499_filer_data.dc_agent_zip">DC Agent Zip</option>
                                        <option key="fcc_499_alt11" value="fcc.499_filer_data.alternate_agent1">Alternate Agent 1</option>
                                        <option key="fcc_499_alt21" value="fcc.499_filer_data.alternate_agent2">Alternate Agent 2</option>
                                        <option key="fcc_499_alt_tel1" value="fcc.499_filer_data.alternate_agent_telephone">Alternate Agent Telephone</option>
                                        <option key="fcc_499_alt_fax1" value="fcc.499_filer_data.alternate_agent_fax">Alternate Agent Fax</option>
                                        <option key="fcc_499_alt_email1" value="fcc.499_filer_data.alternate_agent_email">Alternate Agent Email</option>
                                        <option key="fcc_499_alt_addr11" value="fcc.499_filer_data.alternate_agent_address1">Alternate Agent Address 1</option>
                                        <option key="fcc_499_alt_addr21" value="fcc.499_filer_data.alternate_agent_address2">Alternate Agent Address 2</option>
                                        <option key="fcc_499_alt_addr31" value="fcc.499_filer_data.alternate_agent_address3">Alternate Agent Address 3</option>
                                        <option key="fcc_499_alt_city1" value="fcc.499_filer_data.alternate_agent_city">Alternate Agent City</option>
                                        <option key="fcc_499_alt_state1" value="fcc.499_filer_data.alternate_agent_state">Alternate Agent State</option>
                                        <option key="fcc_499_alt_zip1" value="fcc.499_filer_data.alternate_agent_zip_code">Alternate Agent Zip</option>
                                      </optgroup>
                                    </>
                                  ) : null}
                                  {this.state.is_outbound_sbc_enabled === "Yes" && is_sipnav ? (
                                    <optgroup label="Outbound SBC Configuration">
                                      <option key="sipnav_cps_limit1" value="sipnav.cps_limit">CPS Limit</option>
                                      <option key="sipnav_session_limit1" value="sipnav.session_limit">Session Limit</option>
                                      <option key="sipnav_ring_time1" value="sipnav.ring_time">Ring Time</option>
                                      <option key="sipnav_no_call_progress1" value="sipnav.no_call_progress">No Call Progress</option>
                                      <option key="sipnav_enforce_cid_block1" value="sipnav.enforce_cid_block">Enforce CID Block</option>
                                      <option key="sipnav_cid_block_min_asr1" value="sipnav.cid_block_min_asr">CID Block Min ASR</option>
                                      <option key="sipnav_cid_block_min_acd1" value="sipnav.cid_block_min_acd">CID Block Min ACD</option>
                                      <option key="sipnav_cid_block_max_sdp1" value="sipnav.cid_block_max_sdp">CID Block Max SDP</option>
                                      <option key="sipnav_international_calls1" value="sipnav.international_calls">International Calls</option>
                                      <option key="sipnav_block_wireless1" value="sipnav.block_wireless">Block Wireless</option>
                                      <option key="sipnav_block_dnc1" value="sipnav.block_dnc">Block DNC</option>
                                      <option key="sipnav_remove_cid_name1" value="sipnav.remove_cid_name">Remove CID Name</option>
                                      <option key="sipnav_disable_call_restrictions1" value="sipnav.disable_call_restrictions">Disable Call Restrictions</option>
                                      <option key="sipnav_ani_blacklist1" value="sipnav.ani_blacklist">ANI Blacklist</option>
                                      <option key="sipnav_dnis_blacklist1" value="sipnav.dnis_blacklist">DNIS Blacklist</option>
                                    </optgroup>
                                  ) : null}
                                </MutextField>
                              </div>
                            </div>

                            {account_creation === true &&
                            question.answerType === "input" ? (
                              <div className="col-lg-2">
                                <div className="form-group">
                                  <MutextField
                                    id={`create-account-${question.id}`}
                                    name={`create-account-${question.id}`}
                                    select
                                    label="Select Value for Account Creation"
                                    value={question.createAccount}
                                    onChange={(e) =>
                                      this.handleCreateAccount(
                                        form.id,
                                        question.id,
                                        e.target.value,
                                      )
                                    }
                                    SelectProps={{
                                      native: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                  >
                                    {this.state.accountCreationOptions.map(
                                      (option) => (
                                        <option
                                          key={`opt-2${option.value}`}
                                          value={option.value}
                                          disabled={option.disabled || false}
                                        >
                                          {option.label}
                                        </option>
                                      ),
                                    )}
                                  </MutextField>
                                </div>
                              </div>
                            ) : null}
                            <div className="col-lg-1">
                              <div className="form-group">
                                <MutextField
                                  id={`required-label-${question.id}`}
                                  name={`required-label-${question.id}`}
                                  select
                                  label="Required"
                                  value={question.required.toString()}
                                  onChange={(e) =>
                                    this.handleRequiredChange(
                                      form.id,
                                      question.id,
                                      e.target.value,
                                    )
                                  }
                                  SelectProps={{
                                    native: true,
                                  }}
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="false" value="false">
                                    No
                                  </option>
                                  <option key="true" value="true">
                                    Yes
                                  </option>
                                </MutextField>
                              </div>
                            </div>
                            <div
                              className="col-lg-1"
                              style={{
                                alignContent: "center",
                                display: "flex",
                              }}
                            >
                              <div
                                className=""
                                style={{ alignContent: "center" }}
                              >
                                <a
                                  className={`btn btn-dim btn-danger ${classes.deleteButton}`}
                                  onClick={() =>
                                    this.handleDeleteQuestion(
                                      form.id,
                                      question.id,
                                    )
                                  }
                                >
                                  Delete
                                </a>
                              </div>
                            </div>
                            {question.imageUrl && (
                              <div className="col-lg-12">
                                <img
                                  src={question.imageUrl}
                                  alt="Admin Uploaded"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "200px",
                                    display: "block",
                                  }}
                                />
                              </div>
                            )}
                            {question.answerType === "checkbox" ||
                            question.answerType === "radio" ||
                            question.answerType === "dropdown" ? (
                              <div className="col-lg-6">
                                {question.options.map((option, index) => (
                                  <div
                                    key={`drop_1_${index}`}
                                    className={classes.optionContainer}
                                  >
                                    <MutextField
                                      label={`Option ${index + 1}`}
                                      value={option}
                                      onChange={(e) =>
                                        this.handleOptionChange(
                                          form.id,
                                          question.id,
                                          index,
                                          e.target.value,
                                        )
                                      }
                                      variant="outlined"
                                      fullWidth
                                    />
                                    <a
                                      className={`btn btn-dim btn-danger ${classes.deleteButton}`}
                                      onClick={() =>
                                        this.handleDeleteOption(
                                          form.id,
                                          question.id,
                                          index,
                                        )
                                      }
                                    >
                                      Delete
                                    </a>
                                  </div>
                                ))}
                                <a
                                  className={`btn btn-outline-light`}
                                  onClick={() =>
                                    this.handleAddOption(form.id, question.id)
                                  }
                                  style={{ marginTop: "20px" }}
                                >
                                  Add Option
                                </a>
                              </div>
                            ) : null}
                            {question.answerType === "image_input" ? (
                              <div className="col-lg-4">
                                <input type="file" accept="image/*" disabled />
                              </div>
                            ) : null}
                            {question.answerType === "fixed" ? (
                              <div className="col-lg-7">
                                <div className="form-group">
                                  <MutextField
                                    label="Value"
                                    value={question.answer}
                                    onChange={(e) =>
                                      this.handleFixedOption(
                                        form.id,
                                        question.id,
                                        e.target.value,
                                      )
                                    }
                                    variant="outlined"
                                    fullWidth
                                  />
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              ))}
            </div>
          </>
        ) : null}

        <div className="button-container border-top pt-4">
          <ul className="nk-block-tools g-3" style={{ justifyContent: "End" }}>
            {link_form === false ? (
              <>
                <li className="">
                  <a
                    onClick={() => this.addGroup()}
                    className="btn btn-primary"
                    style={{ color: "#fff", cursor: "pointer" }}
                  >
                    <em className="icon ni ni-plus"></em>
                    <span>Add New Group</span>
                  </a>
                </li>
                {forms.map((form, ffind) => (
                  <li className="" key={`f3-${ffind}`}>
                    <a
                      style={{ cursor: "pointer", color: "#fff" }}
                      onClick={() => this.addNewQuestion(form.id)}
                      className={`btn btn-primary`}
                    >
                      <em className="icon ni ni-plus"></em>
                      <span>Add New Question</span>
                    </a>
                  </li>
                ))}
              </>
            ) : null}
            <li className="nk-block-tools-opt">
              <a
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={this.handleSaveForm}
                className="btn btn-success"
              >
                <em className="icon ni ni-save"></em> &nbsp;Save Form
              </a>
            </li>
          </ul>
        </div>
        <div className="modal fade" tabIndex="-1" id="modalPreviewForm">
          <div
            className="modal-dialog modal-lg modal-dialog-top"
            role="document"
          >
            <div className="modal-content">
              <a
                style={{ cursor: "pointer" }}
                className="close"
                onClick={() => window.$("#modalPreviewForm").modal("hide")}
              >
                <em className="icon ni ni-cross"></em>
              </a>
              <div className="modal-body">
                <div className="nk-modal">{this.state.previewContent}</div>
              </div>
            </div>
          </div>
        </div>
        {/*** ADD GROUP MODAL ***/}
        <div className="modal fade" tabIndex="-1" id="modalAddGroup">
          <div
            className="modal-dialog  modal-xl modal-dialog-top"
            role="document"
          >
            <div className="modal-content">
              <a
                href="#"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <em className="icon ni ni-cross"></em>
              </a>
              <div className="modal-header">
                <h5 className="modal-title">
                  <em className="icon ni ni-plus"></em> <span>Add Group</span>
                </h5>
              </div>
              <div className="modal-body">
                <div id="groupEditDiv">
                  <div className="col-12">
                    {this.state.groupErrorMessage !== "" ? (
                      <div className="example-alert mb-4">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h4>{this.state.groupErrorMessageTitle}</h4>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: this.state.groupErrorMessage,
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.groupSuccessMessage !== "" ? (
                      <div className="example-alert mb-4">
                        <div className="alert alert-pro alert-success">
                          <div className="alert-text">
                            <h4>Success</h4>
                            <p>{this.state.groupSuccessMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="row">
                      <div className="col-md-4">
                        <MutextField
                          required
                          type="text"
                          label="Group Sequence #"
                          value={this.state.currentGroup.sequenceNumber}
                          onChange={this.handleGroupSequenceChange}
                          inputProps={{ maxLength: 3 }}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                          variant="outlined"
                          fullWidth
                          style={{ marginBottom: "20px" }}
                        />
                      </div>
                      <div className="col-md-4">
                        <MutextField
                          required
                          type="text"
                          label="Group Title"
                          value={this.state.currentGroup.group_title}
                          onChange={this.handleGroupTitleChange}
                          inputProps={{ maxLength: 100 }}
                          variant="outlined"
                          fullWidth
                          style={{ marginBottom: "20px" }}
                        />
                      </div>
                      <div className="col-md-4">
                        <MutextField
                          select
                          label="Column Layout"
                          value={
                            this.state.currentGroup.column_layout ||
                            "single_column"
                          }
                          onChange={this.handleGroupColumnLayoutChange}
                          SelectProps={{
                            native: true,
                          }}
                          variant="outlined"
                          fullWidth
                          style={{ marginBottom: "20px" }}
                        >
                          <option value="single_column">Single Column</option>
                          <option value="double_column">Double Column</option>
                        </MutextField>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label className="form-label" for="textOnly2">
                            Tooltip / Instructions
                          </label>
                          <div className="form-control-wrap">
                            <textarea
                              className="form-control"
                              id="group_instructions"
                              name="group_instructions"
                              maxLength={1000}
                              onChange={this.handleGroupTooltipChange}
                              value={this.state.currentGroup.group_instructions}
                            ></textarea>
                          </div>
                          <div
                            className="form-note"
                            style={{ marginTop: "8px" }}
                          >
                            <b>Paragraph:</b> Write free-form text. Use{" "}
                            <b>Enter</b> for new lines. <br />
                            New line will be displayed as a new paragraph on
                            submission page.
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        {for_bcid === true ? (
                          <MutextField
                            select
                            label="Select API"
                            value={this.state.currentGroup.allowBcid}
                            onChange={this.handleGroupAPIChange}
                            SelectProps={{
                              native: true,
                            }}
                            variant="outlined"
                            fullWidth
                          >
                            <option key="ctia0" value=""></option>
                            <option
                              key={`ctia_${this.state.currentGroup.id}`}
                              value="ctia"
                            >
                              CTIA API
                            </option>
                            <option
                              key={`aeges_${this.state.currentGroup.id}`}
                              value="aeges"
                            >
                              Aeges API
                            </option>
                          </MutextField>
                        ) : null}
                      </div>
                    </div>
                    {/*<MutextField
                      required
                      type="text"
                      label="Group Description"
                      value={this.state.currentGroup.group_desc}
                      onChange={this.handleGroupDescChange}
                      inputProps={{ maxLength: 1000 }}
                      helperText="Maximum 1000 characters"
                      variant="outlined"
                      fullWidth
                      style={{ marginBottom: "20px" }}
                    />*/}
                    <div className="form-group">
                      <label className="form-label" for="group_desc1">
                        Description
                      </label>
                      <div className="form-control-wrap">
                        {this.state.isEditorReady ? (
                          <>
                            <RichTextEditorComponent
                              agreementContent={
                                this.state.currentGroup.group_desc
                              }
                              onContentChange={this.handleEditorChange}
                            />
                          </>
                        ) : null}
                        {/*<textarea
                          className="form-control"
                          id="group_desc1"
                          name="group_desc"
                          maxLength={1000}
                          onChange={this.handleGroupDescChange}
                          value={this.state.currentGroup.group_desc}
                        ></textarea>*/}
                      </div>
                    </div>
                    <Select2
                      isMulti
                      name="questions"
                      options={forms[0].questions
                        .filter((question) => {
                          const questionId = question.id;
                          return (
                            !this.state.groups
                              .flatMap((group) => group.questions)
                              .includes(questionId) ||
                            this.state.currentGroup.questions.includes(
                              questionId,
                            )
                          );
                        })
                        .map((question) => ({
                          value: question.id,
                          label: question.questionText,
                        }))}
                      onChange={this.handleSelectChange}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={forms[0].questions
                        .filter((question) =>
                          this.state.currentGroup.questions.includes(
                            question.id,
                          ),
                        )
                        .map((question) => ({
                          value: question.id,
                          label: question.questionText,
                        }))}
                      placeholder="Select questions"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "56px",
                        }),
                        menu: (provided, state) => ({
                          ...provided,
                          zIndex: 9,
                        }),
                      }}
                    />
                    <div className="d-flex justify-content-end">
                      <ul className="nk-block-tools g-3">
                        {this.state.add_group_loader === true ? (
                          <li className="nk-block-tools-opt  mt-3">
                            <button className="btn btn-lg btn-primary" disabled>
                              <em className="icon ni ni-swap"></em> Saving
                              <div
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </button>
                          </li>
                        ) : (
                          <>
                            <li className="nk-block-tools-opt  mt-3">
                              <a
                                style={{ cursor: "pointer", color: "#fff" }}
                                onClick={() => this.closeModal("modalAddGroup")}
                                className={`btn btn-primary btn-lg`}
                              >
                                <em className="icon ni ni-cross-round"></em>
                                <span>Cancel</span>
                              </a>
                            </li>
                            <li className="nk-block-tools-opt  mt-3">
                              <a
                                style={{ cursor: "pointer", color: "#fff" }}
                                onClick={() => this.handleAddGroupNew()}
                                className={`btn btn-primary  btn-lg`}
                              >
                                <em className="icon ni ni-plus"></em>
                                <span>Add Group</span>
                              </a>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*** ADD GROUP MODAL ***/}
        {/*** ADD GROUP MODAL ***/}
        <div className="modal fade" tabIndex="-1" id="modalEditGroup">
          <div
            className="modal-dialog  modal-xl modal-dialog-top"
            role="document"
          >
            <div className="modal-content">
              <a
                href="#"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <em className="icon ni ni-cross"></em>
              </a>
              <div className="modal-header">
                <h5 className="modal-title">
                  <em className="icon ni ni-edit"></em> <span>Edit Group</span>
                </h5>
              </div>
              <div className="modal-body">
                <div id="groupEditDiv1">
                  <div className="col-12">
                    {this.state.groupErrorMessage !== "" ? (
                      <div className="example-alert mb-4">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h4>{this.state.groupErrorMessageTitle}</h4>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: this.state.groupErrorMessage,
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.groupSuccessMessage !== "" ? (
                      <div className="example-alert mb-4">
                        <div className="alert alert-pro alert-success">
                          <div className="alert-text">
                            <h4>Success</h4>
                            <p>{this.state.groupSuccessMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="row">
                      <div className="col-md-4">
                        <MutextField
                          required
                          type="text"
                          label="Group Sequence #"
                          value={this.state.currentGroup.sequenceNumber}
                          onChange={this.handleGroupSequenceChange}
                          inputProps={{ maxLength: 3 }}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                          variant="outlined"
                          fullWidth
                          style={{ marginBottom: "20px" }}
                        />
                      </div>
                      <div className="col-md-4">
                        <MutextField
                          required
                          type="text"
                          label="Group Title"
                          value={this.state.currentGroup.group_title}
                          onChange={this.handleGroupTitleChange}
                          inputProps={{ maxLength: 100 }}
                          variant="outlined"
                          fullWidth
                          style={{ marginBottom: "20px" }}
                        />
                      </div>
                      <div className="col-md-4">
                        <MutextField
                          select
                          label="Column Layout"
                          value={
                            this.state.currentGroup.column_layout ||
                            "single_column"
                          }
                          onChange={this.handleGroupColumnLayoutChange}
                          SelectProps={{
                            native: true,
                          }}
                          variant="outlined"
                          fullWidth
                          style={{ marginBottom: "20px" }}
                        >
                          <option value="single_column">Single Column</option>
                          <option value="double_column">Double Column</option>
                        </MutextField>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label
                            className="form-label"
                            for="group_instructions2"
                          >
                            Tooltip / Instructions
                          </label>
                          <div className="form-control-wrap">
                            <textarea
                              className="form-control"
                              id="group_instructions2"
                              name="group_instructions"
                              maxLength={1000}
                              onChange={this.handleGroupTooltipChange}
                              value={this.state.currentGroup.group_instructions}
                            ></textarea>
                          </div>
                          <div
                            className="form-note"
                            style={{ marginTop: "8px" }}
                          >
                            <b>Paragraph:</b> Write free-form text. Use{" "}
                            <b>Enter</b> for new lines. <br />
                            New line will be displayed as a new paragraph on
                            submission page.
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        {for_bcid === true ? (
                          <MutextField
                            select
                            label="Select API"
                            value={
                              this.state.currentGroup.allowBcid &&
                              this.state.currentGroup.allowBcid !== ""
                                ? this.state.currentGroup.allowBcid
                                : ""
                            }
                            onChange={this.handleGroupAPIChange}
                            SelectProps={{
                              native: true,
                            }}
                            variant="outlined"
                            fullWidth
                          >
                            <option key="ctia0" value=""></option>
                            <option key="ctia" value="ctia">
                              CTIA API
                            </option>
                            <option key="aeges" value="aeges">
                              Aeges API
                            </option>
                          </MutextField>
                        ) : null}
                      </div>
                    </div>
                    {/*<MutextField
                      required
                      type="text"
                      label="Group Description"
                      value={this.state.currentGroup.group_desc}
                      onChange={this.handleGroupDescChange}
                      inputProps={{ maxLength: 1000 }}
                      helperText="Maximum 1000 characters"
                      variant="outlined"
                      fullWidth
                      style={{ marginBottom: "20px" }}
                    />*/}
                    <div className="form-group">
                      <label className="form-label" for="group_desc1">
                        Description
                      </label>
                      <div className="form-control-wrap">
                        {this.state.isEditorReady ? (
                          <>
                            <RichTextEditorComponent
                              agreementContent={
                                this.state.currentGroup.group_desc
                              }
                              onContentChange={this.handleEditorChangeEdit}
                            />
                          </>
                        ) : null}
                        {/*<textarea
                          className="form-control"
                          id="group_desc1"
                          name="group_desc"
                          maxLength={1000}
                          onChange={this.handleGroupDescChange}
                          value={this.state.currentGroup.group_desc}
                        ></textarea>*/}
                      </div>
                    </div>
                    <Select2
                      isMulti
                      name="questions"
                      options={forms[0].questions
                        .filter((question) => {
                          const questionId = question.id;
                          return (
                            !this.state.groups
                              .flatMap((group) => group.questions)
                              .includes(questionId) ||
                            this.state.currentGroup.questions.includes(
                              questionId,
                            )
                          );
                        })
                        .map((question) => ({
                          value: question.id,
                          label: question.questionText,
                        }))}
                      onChange={this.handleSelectChange}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={forms[0].questions
                        .filter((question) =>
                          this.state.currentGroup.questions.includes(
                            question.id,
                          ),
                        )
                        .map((question) => ({
                          value: question.id,
                          label: question.questionText,
                        }))}
                      placeholder="Select questions"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "56px",
                        }),
                        menu: (provided, state) => ({
                          ...provided,
                          zIndex: 9,
                        }),
                      }}
                    />
                    <div className="d-flex justify-content-end">
                      <ul className="nk-block-tools g-3">
                        <li className="nk-block-tools-opt  mt-3">
                          <a
                            style={{ cursor: "pointer", color: "#fff" }}
                            onClick={() => this.closeModal("modalEditGroup")}
                            className={`btn btn-primary btn-lg`}
                          >
                            <em className="icon ni ni-cross-round"></em>
                            <span>Cancel</span>
                          </a>
                        </li>
                        <li className="nk-block-tools-opt  mt-3">
                          <a
                            style={{ cursor: "pointer", color: "#fff" }}
                            onClick={() => this.handleEditGroupNew()}
                            className={`btn btn-primary  btn-lg`}
                          >
                            <em className="icon ni ni-edit"></em>
                            <span>Update Group</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*** ADD GROUP MODAL ***/}
        {/*** ADD QUESTION MODAL ***/}
        <div className="modal fade" tabIndex="-1" id="modalAddQuestion">
          <div
            className="modal-dialog  modal-xl modal-dialog-top"
            role="document"
          >
            <div className="modal-content">
              <a
                href="#"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <em className="icon ni ni-cross"></em>
              </a>
              <div className="modal-header">
                <h5 className="modal-title">
                  <em className="icon ni ni-plus"></em>{" "}
                  <span>Add New Question</span>
                </h5>
              </div>
              <div className="modal-body">
                <div id="questionEditDiv">
                  <div
                    className="col-12"
                    style={{ paddingLeft: "0px", paddingRight: "0px" }}
                  >
                    {this.state.questionErrorMessage !== "" ? (
                      <div className="example-alert mb-4">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h4>{this.state.questionErrorMessageTitle}</h4>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: this.state.questionErrorMessage,
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.questionSuccessMessage !== "" ? (
                      <div className="example-alert mb-4">
                        <div className="alert alert-pro alert-success">
                          <div className="alert-text">
                            <h4>Success</h4>
                            <p>{this.state.questionSuccessMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {/*const newQuestion = [{
                        id: uuid(),
                        questionText: "",
                        answerType: "",
                        required: false,
                        options: [],
                        imageUrl: "",
                        sequenceNumber: "",
                      }];*/}

                    {this.state.newQuestion.map((question, indexes) => (
                      <div
                        key={`input_key_2_${question.id}`}
                        className={classes.questionContainer}
                      >
                        <div className={`row g-4 ${classes.questionTop}`}>
                          <div className="col-lg-2">
                            <MutextField
                              label="Seq #"
                              value={
                                question.sequenceNumber &&
                                question.sequenceNumber !== ""
                                  ? question.sequenceNumber
                                  : ""
                              }
                              onChange={(e) =>
                                this.handleSequenceChange_new(question.id, e)
                              }
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /\D/g,
                                  "",
                                );
                              }}
                              inputProps={{ maxLength: 3 }}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                          <div className="col-lg-10">
                            <div className="form-group">
                              <MutextField
                                label="Question Text *"
                                value={question.questionText}
                                onChange={(e) =>
                                  this.handleQuestionTextChange_new(
                                    question.id,
                                    e,
                                  )
                                }
                                variant="outlined"
                                fullWidth
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <MutextField
                                id={`answer-type-label-${question.id}`}
                                name={`answer-type-label-${question.id}`}
                                select
                                label="Answer Type *"
                                value={question.answerType}
                                onChange={(e) =>
                                  this.handleAnswerTypeChange_new(
                                    question.id,
                                    e,
                                  )
                                }
                                SelectProps={{
                                  native: true,
                                }}
                                variant="outlined"
                                fullWidth
                              >
                                <option key="" value=""></option>
                                <option key="input" value="input">
                                  Input
                                </option>
                                <option key="textarea" value="textarea">
                                  Textarea
                                </option>
                                <option key="dropdown" value="dropdown">
                                  Dropdown
                                </option>
                                <option key="input3" value="label">
                                  Label
                                </option>
                                <option key="text_only3" value="text_only">
                                  Plain Text
                                </option>
                                <option key="rich_text3" value="rich_text">
                                  Rich Text
                                </option>
                                <option
                                  key="notice_text3"
                                  value="notice_text"
                                >
                                  Notice Text
                                </option>
                                <option
                                  key="warning_text3"
                                  value="warning_text"
                                >
                                  Warning Text
                                </option>
                                <option key="fixed" value="fixed">
                                  Fixed Fields
                                </option>
                                <option key="signature" value="signature">
                                  Signature
                                </option>
                                <option key="checkbox" value="checkbox">
                                  Checkbox
                                </option>
                                <option key="radio" value="radio">
                                  Radio
                                </option>
                                <option key="image_input" value="image_input">
                                  Image Input
                                </option>
                                <option key="datetime" value="datetime">
                                  Datetime
                                </option>
                                <option key="date" value="date">
                                  Date
                                </option>
                                <option key="time" value="time">
                                  Time
                                </option>
                              </MutextField>
                            </div>
                          </div>
                          {!this.isStaticTextAnswerType(question.answerType) ? (
                            <div className="col-lg-6">
                            <div className="form-group">
                              <MutextField
                                id={`dynamic-value-${question.id}`}
                                name={`dynamic-value-${question.id}`}
                                select
                                label="Dynamic Value"
                                value={question.dynamicValue}
                                onChange={(e) =>
                                  this.handleDynamicValue_new(question.id, e)
                                }
                                SelectProps={{
                                  native: true,
                                }}
                                variant="outlined"
                                fullWidth
                              >
                                <option key="" value=""></option>
                                <option key="input" value="fullname">
                                  Full Name
                                </option>
                                <option key="company2" value="company">
                                  Company
                                </option>
                                <option key="email2" value="email">
                                  Email Address
                                </option>
                                <option key="phone2" value="phone">
                                  Phone
                                </option>
                                <option
                                  key="full_address2"
                                  value="full_address"
                                >
                                  Full Address
                                </option>
                                <option key="address2" value="address">
                                  Address
                                </option>
                                <option key="appartment2" value="appartment">
                                  Appartment, Suite
                                </option>
                                <option key="city2" value="city">
                                  City
                                </option>
                                <option key="state2" value="state">
                                  State
                                </option>
                                <option key="zip2" value="zip">
                                  Zip
                                </option>
                                <option key="country2" value="country">
                                  Country
                                </option>
                                {this.state.is_fcc_enabled === "Yes" ? (
                                  <>
                                    <optgroup label="FCC - Robocall Data">
                                      <option key="fcc_rb_number2" value="fcc.robocall_data.number">Number</option>
                                      <option key="fcc_rb_frn2" value="fcc.robocall_data.frn">FRN</option>
                                      <option key="fcc_rb_business_name2" value="fcc.robocall_data.business_name">Business Name</option>
                                      <option key="fcc_rb_business_address2" value="fcc.robocall_data.business_address">Business Address</option>
                                      <option key="fcc_rb_country2" value="fcc.robocall_data.country">Country</option>
                                      <option key="fcc_rb_contact_name2" value="fcc.robocall_data.robocall_mitigation_contact_name">Contact Name</option>
                                      <option key="fcc_rb_contact_title2" value="fcc.robocall_data.contact_title">Contact Title</option>
                                      <option key="fcc_rb_contact_department2" value="fcc.robocall_data.contact_department">Contact Department</option>
                                      <option key="fcc_rb_contact_business_address2" value="fcc.robocall_data.contact_business_address">Contact Business Address</option>
                                      <option key="fcc_rb_contact_country2" value="fcc.robocall_data.contact_country">Contact Country</option>
                                      <option key="fcc_rb_contact_telephone2" value="fcc.robocall_data.contact_telephone_number">Contact Telephone</option>
                                      <option key="fcc_rb_contact_email2" value="fcc.robocall_data.contact_email">Contact Email</option>
                                      <option key="fcc_rb_filing_url2" value="fcc.robocall_data.filing_url">Filing URL</option>
                                      <option key="fcc_rb_ocn2" value="fcc.robocall_data.ocn">OCN</option>
                                      <option key="fcc_rb_holding_company2" value="fcc.robocall_data.holding_company">Holding Company</option>
                                    </optgroup>
                                    <optgroup label="FCC - 499 Filer Data">
                                      <option key="fcc_499_filer_id2" value="fcc.499_filer_data.filer_499_id">Filer 499 ID</option>
                                      <option key="fcc_499_lastfiling2" value="fcc.499_filer_data.lastfiling">Last Filing</option>
                                      <option key="fcc_499_legal_name2" value="fcc.499_filer_data.legal_name_of_carrier">Legal Name of Carrier</option>
                                      <option key="fcc_499_comm_type2" value="fcc.499_filer_data.principal_comm_type_1">Principal Comm Type</option>
                                      <option key="fcc_499_holding2" value="fcc.499_filer_data.holding_company">Holding Company</option>
                                      <option key="fcc_499_hq_addr12" value="fcc.499_filer_data.hq_address1">HQ Address 1</option>
                                      <option key="fcc_499_hq_addr22" value="fcc.499_filer_data.hq_address2">HQ Address 2</option>
                                      <option key="fcc_499_hq_city2" value="fcc.499_filer_data.hq_city">HQ City</option>
                                      <option key="fcc_499_hq_state2" value="fcc.499_filer_data.hq_state">HQ State</option>
                                      <option key="fcc_499_hq_zip2" value="fcc.499_filer_data.hq_zip_code">HQ Zip Code</option>
                                      <option key="fcc_499_ci_addr12" value="fcc.499_filer_data.customer_inquiries_address1">Customer Inquiries Address 1</option>
                                      <option key="fcc_499_ci_addr22" value="fcc.499_filer_data.customer_inquiries_address2">Customer Inquiries Address 2</option>
                                      <option key="fcc_499_ci_addr32" value="fcc.499_filer_data.customer_inquiries_address3">Customer Inquiries Address 3</option>
                                      <option key="fcc_499_ci_city2" value="fcc.499_filer_data.customer_inquiries_city">Customer Inquiries City</option>
                                      <option key="fcc_499_ci_state2" value="fcc.499_filer_data.customer_inquiries_state">Customer Inquiries State</option>
                                      <option key="fcc_499_ci_zip2" value="fcc.499_filer_data.customer_inquiries_zip_code">Customer Inquiries Zip</option>
                                      <option key="fcc_499_ci_tel2" value="fcc.499_filer_data.customer_inquiries_telephone">Customer Inquiries Telephone</option>
                                      <option key="fcc_499_trade12" value="fcc.499_filer_data.other_trade_name1">Other Trade Name 1</option>
                                      <option key="fcc_499_trade22" value="fcc.499_filer_data.other_trade_name2">Other Trade Name 2</option>
                                      <option key="fcc_499_dc12" value="fcc.499_filer_data.dc_agent1">DC Agent 1</option>
                                      <option key="fcc_499_dc22" value="fcc.499_filer_data.dc_agent2">DC Agent 2</option>
                                      <option key="fcc_499_dc_tel2" value="fcc.499_filer_data.dc_agent_telephone">DC Agent Telephone</option>
                                      <option key="fcc_499_dc_fax2" value="fcc.499_filer_data.dc_agent_fax">DC Agent Fax</option>
                                      <option key="fcc_499_dc_email2" value="fcc.499_filer_data.dc_agent_email">DC Agent Email</option>
                                      <option key="fcc_499_dc_addr12" value="fcc.499_filer_data.dc_agent_address1">DC Agent Address 1</option>
                                      <option key="fcc_499_dc_addr22" value="fcc.499_filer_data.dc_agent_address2">DC Agent Address 2</option>
                                      <option key="fcc_499_dc_addr32" value="fcc.499_filer_data.dc_agent_address3">DC Agent Address 3</option>
                                      <option key="fcc_499_dc_city2" value="fcc.499_filer_data.dc_agent_city">DC Agent City</option>
                                      <option key="fcc_499_dc_state2" value="fcc.499_filer_data.dc_agent_state">DC Agent State</option>
                                      <option key="fcc_499_dc_zip2" value="fcc.499_filer_data.dc_agent_zip">DC Agent Zip</option>
                                      <option key="fcc_499_alt12" value="fcc.499_filer_data.alternate_agent1">Alternate Agent 1</option>
                                      <option key="fcc_499_alt22" value="fcc.499_filer_data.alternate_agent2">Alternate Agent 2</option>
                                      <option key="fcc_499_alt_tel2" value="fcc.499_filer_data.alternate_agent_telephone">Alternate Agent Telephone</option>
                                      <option key="fcc_499_alt_fax2" value="fcc.499_filer_data.alternate_agent_fax">Alternate Agent Fax</option>
                                      <option key="fcc_499_alt_email2" value="fcc.499_filer_data.alternate_agent_email">Alternate Agent Email</option>
                                      <option key="fcc_499_alt_addr12" value="fcc.499_filer_data.alternate_agent_address1">Alternate Agent Address 1</option>
                                      <option key="fcc_499_alt_addr22" value="fcc.499_filer_data.alternate_agent_address2">Alternate Agent Address 2</option>
                                      <option key="fcc_499_alt_addr32" value="fcc.499_filer_data.alternate_agent_address3">Alternate Agent Address 3</option>
                                      <option key="fcc_499_alt_city2" value="fcc.499_filer_data.alternate_agent_city">Alternate Agent City</option>
                                      <option key="fcc_499_alt_state2" value="fcc.499_filer_data.alternate_agent_state">Alternate Agent State</option>
                                      <option key="fcc_499_alt_zip2" value="fcc.499_filer_data.alternate_agent_zip_code">Alternate Agent Zip</option>
                                    </optgroup>
                                  </>
                                ) : null}
                                {this.state.is_outbound_sbc_enabled === "Yes" && is_sipnav ? (
                                  <optgroup label="Outbound SBC Configuration">
                                    <option key="sipnav_cps_limit2" value="sipnav.cps_limit">CPS Limit</option>
                                    <option key="sipnav_session_limit2" value="sipnav.session_limit">Session Limit</option>
                                    <option key="sipnav_ring_time2" value="sipnav.ring_time">Ring Time</option>
                                    <option key="sipnav_no_call_progress2" value="sipnav.no_call_progress">No Call Progress</option>
                                    <option key="sipnav_enforce_cid_block2" value="sipnav.enforce_cid_block">Enforce CID Block</option>
                                    <option key="sipnav_cid_block_min_asr2" value="sipnav.cid_block_min_asr">CID Block Min ASR</option>
                                    <option key="sipnav_cid_block_min_acd2" value="sipnav.cid_block_min_acd">CID Block Min ACD</option>
                                    <option key="sipnav_cid_block_max_sdp2" value="sipnav.cid_block_max_sdp">CID Block Max SDP</option>
                                    <option key="sipnav_international_calls2" value="sipnav.international_calls">International Calls</option>
                                    <option key="sipnav_block_wireless2" value="sipnav.block_wireless">Block Wireless</option>
                                    <option key="sipnav_block_dnc2" value="sipnav.block_dnc">Block DNC</option>
                                    <option key="sipnav_remove_cid_name2" value="sipnav.remove_cid_name">Remove CID Name</option>
                                    <option key="sipnav_disable_call_restrictions2" value="sipnav.disable_call_restrictions">Disable Call Restrictions</option>
                                    <option key="sipnav_ani_blacklist2" value="sipnav.ani_blacklist">ANI Blacklist</option>
                                    <option key="sipnav_dnis_blacklist2" value="sipnav.dnis_blacklist">DNIS Blacklist</option>
                                  </optgroup>
                                ) : null}
                              </MutextField>
                            </div>
                            </div>
                          ) : null}
                          {account_creation === true &&
                          question.answerType === "input" ? (
                            <div className="col-lg-6">
                              <div className="form-group">
                                <MutextField
                                  id={`create-account-${question.id}`}
                                  name={`create-account-${question.id}`}
                                  select
                                  label="Select Value for Account Creation"
                                  value={question.createAccount}
                                  onChange={(e) =>
                                    this.handleCreateAccount_new(question.id, e)
                                  }
                                  SelectProps={{
                                    native: true,
                                  }}
                                  variant="outlined"
                                  fullWidth
                                >
                                  {this.state.accountCreationOptions.map(
                                    (option) => (
                                      <option
                                        key={`opt-3${option.value}`}
                                        value={option.value}
                                        disabled={option.disabled || false}
                                      >
                                        {option.label}
                                      </option>
                                    ),
                                  )}
                                </MutextField>
                              </div>
                            </div>
                          ) : null}
                          {!this.isStaticTextAnswerType(question.answerType) ? (
                            <div className="col-lg-6">
                              <div className="form-group">
                                <MutextField
                                  id={`required-label-${question.id}`}
                                  name={`required-label-${question.id}`}
                                  select
                                  label="Required"
                                  value={question.required}
                                  onChange={(e) =>
                                    this.handleRequiredChange_new(question.id, e)
                                  }
                                  SelectProps={{
                                    native: true,
                                  }}
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="false" value="false">
                                    No
                                  </option>
                                  <option key="true" value="true">
                                    Yes
                                  </option>
                                </MutextField>
                              </div>
                            </div>
                          ) : null}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <MutextField
                                id="selected_group"
                                name="selected_group"
                                select
                                label="Select Group *"
                                value={this.state.selected_group}
                                onChange={this.handleChange}
                                SelectProps={{
                                  native: true,
                                }}
                                variant="outlined"
                                fullWidth
                              >
                                <option key="" value=""></option>
                                {this.state.groups &&
                                this.state.groups.length > 0 ? (
                                  <>
                                    {this.state.groups.map((group, index) => (
                                      <option
                                        key={`add_group2_${index}`}
                                        value={group.id}
                                      >
                                        {group.group_title}
                                      </option>
                                    ))}
                                  </>
                                ) : null}
                              </MutextField>
                            </div>
                          </div>

                          {question.answerType === "input" ? (
                            <div className="col-lg-6">
                              <div className="form-group">
                                <MutextField
                                  id={`validation-value-${question.id}`}
                                  name={`validation-value--${question.id}`}
                                  select
                                  label="Validations"
                                  value={question.validationValue}
                                  onChange={(e) =>
                                    this.handleValidationValueChange_new(
                                      question.id,
                                      e,
                                    )
                                  }
                                  SelectProps={{
                                    native: true,
                                  }}
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="" value=""></option>
                                  <option
                                    key="validation_email"
                                    value="validation_email"
                                  >
                                    Email Address
                                  </option>
                                  <option
                                    key="validation_fulladdress"
                                    value="validation_fulladdress"
                                  >
                                    Full Address
                                  </option>
                                  <option
                                    key="validation_phone"
                                    value="validation_phone"
                                  >
                                    Phone Number
                                  </option>
                                  <option
                                    key="validation_ip"
                                    value="validation_ip"
                                  >
                                    IP Address
                                  </option>
                                  <option
                                    key="validation_filerId"
                                    value="validation_filerId"
                                  >
                                    FCC 499 Filer
                                  </option>
                                  <option
                                    key="validation_address"
                                    value="validation_address"
                                  >
                                    Address
                                  </option>
                                  <option
                                    key="validation_city"
                                    value="validation_city"
                                  >
                                    City
                                  </option>
                                  <option
                                    key="validation_state"
                                    value="validation_state"
                                  >
                                    State
                                  </option>
                                  <option
                                    key="validation_zip"
                                    value="validation_zip"
                                  >
                                    Zip
                                  </option>
                                  <option
                                    key="validation_country"
                                    value="validation_country"
                                  >
                                    Country
                                  </option>
                                </MutextField>
                              </div>
                            </div>
                          ) : null}

                          {question.answerType === "input" ||
                          question.answerType === "textarea" ? (
                            <div className="col-lg-6">
                              <div className="form-group">
                                <MutextField
                                  label="Max Length"
                                  value={question.maxLength}
                                  onChange={(e) =>
                                    this.handleMaxLengthChange_new(
                                      question.id,
                                      e,
                                    )
                                  }
                                  onKeyPress={(e) => {
                                    if (
                                      (!/[0-9]/.test(e.key) &&
                                        e.key !== "Backspace" &&
                                        e.key !== "Delete") ||
                                      (e.target.value.length >= 3 &&
                                        /[0-9]/.test(e.key))
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>
                            </div>
                          ) : null}

                          {question.answerType === "input" ||
                          question.answerType === "textarea" ? (
                            <div className="col-lg-6">
                              <div className="form-group">
                                <MutextField
                                  id={`input-format-${question.id}`}
                                  name={`input-format--${question.id}`}
                                  select
                                  label="Input Format"
                                  value={question.inputFormat}
                                  onChange={(e) =>
                                    this.handleInputFormatChange_new(
                                      question.id,
                                      e,
                                    )
                                  }
                                  SelectProps={{
                                    native: true,
                                  }}
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="" value=""></option>
                                  <option key="number_only" value="number_only">
                                    Number Only
                                  </option>
                                  <option
                                    key="alphabet_only"
                                    value="alphabet_only"
                                  >
                                    Alphabet Only
                                  </option>
                                  <option
                                    key="alphanumeric"
                                    value="alphanumeric"
                                  >
                                    Alphanumeric
                                  </option>
                                  <option key="open" value="open">
                                    Open (No Restrictions)
                                  </option>
                                </MutextField>
                              </div>
                            </div>
                          ) : null}

                          {question.imageUrl && (
                            <div className="col-lg-12">
                              <img
                                src={question.imageUrl}
                                alt="Admin Uploaded"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "200px",
                                  display: "block",
                                }}
                              />
                            </div>
                          )}
                          {question.answerType === "checkbox" ||
                          question.answerType === "radio" ||
                          question.answerType === "dropdown" ? (
                            <div className="col-lg-12">
                              {question.options.map((option, index) => (
                                <div
                                  key={`drop_3_${index}`}
                                  className={classes.optionContainer}
                                >
                                  <MutextField
                                    label={`Option ${index + 1}`}
                                    value={option}
                                    onChange={(e) =>
                                      this.handleOptionChange_new(
                                        question.id,
                                        index,
                                        e,
                                      )
                                    }
                                    variant="outlined"
                                    fullWidth
                                  />
                                  <a
                                    className={`btn btn-dim btn-danger ${classes.deleteButton}`}
                                    onClick={() =>
                                      this.handleDeleteOption_new(
                                        question.id,
                                        index,
                                      )
                                    }
                                  >
                                    Delete
                                  </a>
                                </div>
                              ))}
                              <a
                                className={`btn btn-outline-light`}
                                onClick={() =>
                                  this.handleAddOption_new(question.id)
                                }
                                style={{ marginTop: "20px" }}
                              >
                                Add Option
                              </a>
                            </div>
                          ) : null}
                          {question.answerType === "image_input" ? (
                            <div className="col-lg-12">
                              <input type="file" accept="image/*" disabled />
                            </div>
                          ) : null}
                          {question.answerType === "fixed" ? (
                            <div className="col-lg-12">
                              <div className="form-group">
                                <MutextField
                                  label="Value"
                                  value={question.answer}
                                  onChange={(e) =>
                                    this.handleFixedOption_new(question.id, e)
                                  }
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>
                            </div>
                          ) : null}
                          {question.answerType === "text_only" ? (
                            <>
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <MutextField
                                    id="textType2"
                                    name="textType"
                                    select
                                    label="Text Type"
                                    value={question.textType || "p"}
                                    onChange={(e) =>
                                      this.handleTextTypeChange_new(
                                        question.id,
                                        e,
                                      )
                                    }
                                    SelectProps={{
                                      native: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                  >
                                    <option key="Paragraph2" value="p">
                                      Paragraph
                                    </option>
                                    <option key="li3" value="oli">
                                      Ordered List
                                    </option>
                                    <option key="li4" value="sli">
                                      Simple List
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label className="form-label" for="textOnly2">
                                    Enter Text
                                  </label>
                                  <div className="form-control-wrap">
                                    <textarea
                                      className="form-control"
                                      id="textOnly1"
                                      name="textOnly"
                                      maxLength={1000}
                                      onChange={(e) =>
                                        this.handleTextOnlyChange_new(
                                          question.id,
                                          e,
                                        )
                                      }
                                      value={question.textOnly}
                                    ></textarea>
                                  </div>
                                  <div
                                    className="form-note"
                                    style={{ marginTop: "8px" }}
                                  >
                                    <b>Paragraph:</b> Write free-form text. Use{" "}
                                    <b>Enter</b> for new lines. <br />
                                    <b>Ordered List:</b> Press <b>Enter</b>{" "}
                                    after each line to create a numbered list.{" "}
                                    <br />
                                    <b>Simple List:</b> Press <b>Enter</b> after
                                    each line to create a bulleted list. <br />
                                    Maximum 5000 characters are allowed.
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                          {this.isRichEditorAnswerType(question.answerType) ? (
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label className="form-label">Enter Content</label>
                                <div className="form-control-wrap">
                                  <RichTextEditorComponent
                                    key={question.answerType}
                                    answerType={question.answerType}
                                    agreementContent={question.textOnly || ""}
                                    onContentChange={(updatedContent) =>
                                      this.handleTextOnlyRichChange_new(
                                        question.id,
                                        updatedContent,
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {!this.isStaticTextAnswerType(question.answerType) && (
                            <div className="col-lg-12">
                              <div className="form-group">
                                <div className="form-control-wrap">
                                  <MutextField
                                    label="Tooltip / Help Text"
                                    value={question.tooltip}
                                    onChange={(e) =>
                                      this.handleTooltipChange_new(
                                        question.id,
                                        e,
                                      )
                                    }
                                    variant="outlined"
                                    fullWidth
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div className="d-flex align-items-center gap-4">
                        {(this.state.currentAnswerType === "input" ||
                          this.state.currentAnswerType === "textarea") &&
                          this.state.chatgpt_intergation === "Yes" && ( // 👈 only show if enabled
                            <div className="form-group d-flex align-items-center mb-0">
                              <label
                                className="form-label mb-0"
                                style={{
                                  marginRight: "10px",
                                  fontWeight: "500",
                                }}
                              >
                                AI Assistance
                              </label>
                              <div className="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="allow-ai-question"
                                  checked={this.state.allowAIQuestion}
                                  onChange={this.handleAllowAIQuestionChange}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="allow-ai-question"
                                ></label>
                              </div>
                            </div>
                          )}
                      </div>

                      {/* ✅ Right side: Action buttons */}
                      <ul className="nk-block-tools g-3 mb-0">
                        {this.state.add_question_loader === true ? (
                          <li className="nk-block-tools-opt mt-3">
                            <button className="btn btn-lg btn-primary" disabled>
                              <em className="icon ni ni-swap"></em> Saving
                              <div
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </button>
                          </li>
                        ) : (
                          <>
                            <li className="nk-block-tools-opt mt-3">
                              <a
                                style={{ cursor: "pointer", color: "#fff" }}
                                onClick={() =>
                                  this.closeModal("modalAddQuestion")
                                }
                                className={`btn btn-primary btn-lg`}
                              >
                                <em className="icon ni ni-cross-round"></em>
                                <span>Cancel</span>
                              </a>
                            </li>
                            <li className="nk-block-tools-opt mt-3">
                              <a
                                style={{ cursor: "pointer", color: "#fff" }}
                                onClick={() => this.submitNewQuestion()}
                                className={`btn btn-primary btn-lg`}
                              >
                                <em className="icon ni ni-plus"></em>
                                <span>Add Question</span>
                              </a>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*** ADD QUESTION MODAL ***/}

        {/*** DELETE GROUP MODAL ***/}
        <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
          <div
            className="modal-dialog modal-lg modal-dialog-top"
            role="document"
          >
            <div className="modal-content">
              <a
                style={{ cursor: "pointer" }}
                className="close"
                onClick={() => this.closeDelForm()}
              >
                <em className="icon ni ni-cross"></em>
              </a>
              <div className="modal-body modal-body-lg text-center">
                <div className="nk-modal">
                  <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-danger"></em>

                  <h4 className="nk-modal-title">Delete Group?</h4>
                  <div className="nk-modal-text">
                    {this.state.groupErrorMessage !== "" ? (
                      <div className="example-alert mb-4">
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h4>Error</h4>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: this.state.groupErrorMessage,
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.groupSuccessMessage !== "" ? (
                      <div className="example-alert mb-4">
                        <div className="alert alert-pro alert-success">
                          <div className="alert-text">
                            <h4>Success</h4>
                            <p>{this.state.groupSuccessMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div className="caption-text">
                      <p>
                        <b>Delete Group & Questions: </b> Once deleted, all
                        questions within this group will be permanently
                        removed.{" "}
                      </p>

                      <p>
                        <b>Delete Group: </b> Once deleted, all the questions in
                        this group must be reassigned to another group. <br />
                      </p>
                    </div>
                  </div>
                  <div className="nk-modal-action">
                    <a
                      style={{ cursor: "pointer" }}
                      className="btn btn-mw btn-primary"
                      onClick={() => this.closeDelForm()}
                    >
                      CANCEL
                    </a>
                    {"  "}
                    {this.state.isDeleting ? null : (
                      <a
                        style={{ cursor: "pointer", marginRight: "5px" }}
                        className={
                          this.state.isDeletingAll
                            ? "btn btn-light"
                            : "btn btn-mw btn-danger"
                        }
                        onClick={() => {
                          this.deleteGroupandQuestions();
                        }}
                        disabled={this.state.isDeletingAll}
                      >
                        {this.state.isDeletingAll
                          ? "DELETING..."
                          : "DELETE GROUP & QUESTIONS"}
                      </a>
                    )}
                    {this.state.isDeletingAll ? null : (
                      <a
                        style={{ cursor: "pointer" }}
                        className={
                          this.state.isDeleting
                            ? "btn btn-light"
                            : "btn btn-mw btn-danger"
                        }
                        onClick={() => {
                          this.deleteGroup();
                        }}
                        disabled={this.state.isDeleting}
                      >
                        {this.state.isDeleting ? "DELETING..." : "DELETE GROUP"}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*** DELETE GROUP MODAL ***/}
      </div>
    );
  }
}

export default withStyles(useStyles)(FormBuilderClass);
